/* Murmure : configurateur pêle-mêle (collage multi-photos sur la fiche perso).
   Le produit porte les tags Personnalisable + Pêle-mêle : toute la mécanique perso
   (épinglage, rangée CTA, endpoint d'upload) reste à product.js ; ICI vivent le choix
   du gabarit, la pile de photos, le rendu et l'ajout au panier. Une seule fonction de
   dessin sert l'aperçu (canvas dans le cadre) ET le fichier d'impression (2200x3178) :
   ce que le client voit est exactement ce qui part à l'atelier (_perso_crop_ok=1).

   Philosophie (Adrien, 03/08/2026) : pas de mise en page imposée, des TYPES de
   layout avec des options. Grille décalée : nombre de photos 2 par 2. Grande
   grille : nombre de cases + style de texte. Damier : les lettres du client.
   Plein bord : nombre de photos. Le nombre : le nombre et les mots. */
(function () {
  "use strict";
  if (!window.__pdpPeleMele) return;

  var T = window.__pdpPeleMeleT || {};
  /* Le filtre de traduction Shopify échappe les apostrophes (&#39;) : décodées ici,
     sinon « l&#39;amour » partait tel quel dans le canvas (03/08/2026). */
  (function () {
    var bac = document.createElement("textarea");
    Object.keys(T).forEach(function (k) {
      if (typeof T[k] === "string" && T[k].indexOf("&") !== -1) {
        bac.innerHTML = T[k];
        T[k] = bac.value;
      }
    });
  })();
  var TI = window.MURMURE_I18N || {};
  var $ = function (s) { return document.querySelector(s); };
  var RATIO = 0.6923;

  /* Polices : toutes déclarées en @font-face global dans base.css (great-vibes.ttf,
     cormorant.ttf) ; document.fonts.load les tire avant la première composition. */
  var SERIF = '"Cormorant Garamond", Georgia, serif';
  var SANS = '"Helvetica Neue", Helvetica, Arial, sans-serif';
  var SCRIPT = '"Great Vibes", "Apple Chancery", cursive';
  var MACHINE = '"Courier New", Courier, monospace';
  var CHIFFRES = '"Arial Rounded MT Bold", "Helvetica Neue", "Arial Black", Arial, sans-serif';
  /* ⛔ Les LETTRES ne prennent pas la police des chiffres : Arial Rounded a des
     terminaisons arrondies, donc les découpes sortaient avec des coins ronds, et
     ses fûts paraissaient fins une fois le mot ramené à la bande centrale
     (Adrien, 03/08/2026, captures zoomées). Une graisse noire à bouts droits. */
  var LETTRES = '"Arial Black", "Helvetica Neue", Impact, Arial, sans-serif';

  var CHAMPS_GRILLE = {
    filets: [{ cle: "titre", defaut: T.d_titre || "FAMILY", max: 24 },
             { cle: "sous", defaut: T.d_tagline || "is the home of our heart", max: 60 }],
    lettres: [{ cle: "titre", defaut: T.d_histoire || "LOVESTORY", max: 24 },
              { cle: "sous", defaut: T.d_sous || "YOU AND ME", max: 32 },
              { cle: "para", defaut: T.d_para || "", max: 160 }],
    sans: []
  };
  /* Plein bord n'est plus une mise en page : c'est un STYLE de la grille décalée
     (Adrien, 03/08/2026). Chaque style garde son propre nombre de cases. */
  var CHAMPS_DECALEE = {
    decalee: [{ cle: "legende", defaut: T.d_joie || "MOMENTS OF JOY", max: 40 }],
    "plein-bord": [],
    /* Le mot manuscrit, la légende et les coordonnées vont ensemble : un mot posé sur les
       photos, la phrase qui dit ce que c'était, et le point exact où c'était. Séparés, les
       trois champs perdent leur raison d'être. Les valeurs par défaut sont les NÔTRES : voir
       la mémoire modeles-concurrents-mise-en-page, on reprend une mise en page, jamais un
       texte, pas même en valeur par défaut. */
    manuscrit: [{ cle: "mot", defaut: T.d_ensemble || "Ensemble", max: 12 },
                { cle: "legende", defaut: T.d_commence || "Là où tout a commencé", max: 40 },
                { cle: "coord", defaut: "", ph: T.d_coord || "48° 8' 13.9\" N", max: 28 }]
  };
  var GABARITS = [
    { id: "decalee", nom: T.decalee || "Grille décalée", textes: [] },
    { id: "grille", nom: T.grille || "Grande grille", textes: [] },
    { id: "lignes", nom: T.lignes || "Lignes", textes: [] },
    { id: "damier-love", nom: T.damier || "Damier LOVE",
      textes: [{ cle: "lettres", defaut: T.amour || "LOVE", max: 8, geometrie: true }] },
    { id: "lettres", nom: T.lettres || "Mot en photos",
      textes: [{ cle: "sur", defaut: T.l_sur || "THE BEST", max: 24 },
               { cle: "mot", defaut: T.l_mot || "DAD", max: 7, geometrie: true },
               { cle: "sous", defaut: T.l_sous || "IN THE WORLD", max: 24 },
               { cle: "para", defaut: T.l_para || "", max: 200 },
               { cle: "noms", defaut: "", ph: "CAMILLE & LUCAS", max: 32 }] },
    { id: "coeur", nom: T.coeur || "Cœur", textes: [] },
    { id: "nombre", nom: T.nombre || "Le nombre",
      textes: [{ cle: "mot1", defaut: T.d_mot1 || "wonderful", max: 18 }, { cle: "mot2", defaut: T.d_mot2 || "years", max: 18 },
               { cle: "noms", defaut: "", ph: "CAMILLE & LUCA", max: 32 }] }
  ];
  function gabarit() { return GABARITS.filter(function (g) { return g.id === etat.gabarit; })[0] || GABARITS[0]; }

  /* Nombre de cases par gabarit : défaut, [min, max, pas]. */
  var COMPTES_DEF = { grille: 16, lignes: 3, decalee: 6, "plein-bord": 5, manuscrit: 8, coeur: 6, lettres: 6 };
  var COMPTES_LIM = { grille: [2, 48, 1], lignes: [2, 8, 1], decalee: [2, 12, 2], "plein-bord": [2, 10, 1],
    manuscrit: [4, 16, 2], coeur: [4, 60, 1], lettres: [2, 40, 1] };

  /* ---- État ---- */
  var HANDLE = (window.__pdpRecent && window.__pdpRecent.handle) || location.pathname;
  var CLE_SESSION = "pelemele:" + HANDLE;
  var sessionARestaurer = null;
  var etat = { gabarit: "decalee", nombre: "30", texteStyle: "filets", coeurStyle: "bandes", decaleeStyle: "decalee",
    comptes: {}, textes: {}, police: null, fond: "blanc", encres: {}, polices: {} };
  try {
    var lu = JSON.parse(sessionStorage.getItem(CLE_SESSION) || "null");
    if (lu && typeof lu === "object") {
      /* Sessions des versions précédentes : anciens identifiants de gabarits. */
      if (lu.g === "grille-30") { lu.g = "grille"; lu.s = lu.s || "filets"; }
      if (lu.g === "grille-9") { lu.g = "grille"; lu.s = lu.s || "lettres"; }
      if (lu.g === "grille-6") lu.g = "decalee";
      if (lu.g === "plein-bord-5") lu.g = "plein-bord";
      if (lu.g === "plein-bord") { lu.g = "decalee"; lu.ds = lu.ds || "plein-bord"; }
      if (GABARITS.some(function (g) { return g.id === lu.g; })) etat.gabarit = lu.g;
      if (typeof lu.n === "string") etat.nombre = lu.n;
      if (["filets", "lettres", "sans"].indexOf(lu.s) !== -1) etat.texteStyle = lu.s;
      if (lu.k && typeof lu.k === "object") etat.comptes = lu.k;
      if (typeof lu.c === "string" && etat.comptes.grille == null) etat.comptes.grille = lu.c;
      if (lu.t && typeof lu.t === "object") {
        etat.textes = lu.t;
        if (lu.t["grille-6"] && !lu.t.decalee) etat.textes.decalee = lu.t["grille-6"];
        var vieux = lu.t["grille-30"] || lu.t["grille-9"];
        if (vieux && !lu.t.grille) etat.textes.grille = vieux;
      }
      if (typeof lu.p === "string") etat.police = lu.p;
      if (typeof lu.f === "string") etat.fond = lu.f;
      if (lu.ec && typeof lu.ec === "object") etat.encres = lu.ec;
      if (lu.pc && typeof lu.pc === "object") etat.polices = lu.pc;
      if (typeof lu.cs === "string") etat.coeurStyle = lu.cs;
      if (typeof lu.ds === "string") etat.decaleeStyle = lu.ds;
      if (Array.isArray(lu.ph) && lu.ph.length) sessionARestaurer = lu;
    }
  } catch (e) {}
  /* ?layout=coeur (ou decalee, grille, damier, pleinbord, nombre) présélectionne la
     mise en page : les publicités et les guides pointent directement le bon layout. */
  try {
    var qs = new URLSearchParams(location.search);
    var vise = (qs.get("layout") || qs.get("gabarit") || "").toLowerCase();
    /* ⛔ TOUT LAYOUT DOIT AVOIR SON ALIAS. « Lignes » et « Mot manuscrit » sont sortis sans le
       leur : leurs URL retombaient en silence sur la grille décalée, et une publicité pointée
       dessus vendait autre chose que ce qu'elle montrait (Adrien, 04/08/2026). */
    var ALIAS = { decalee: "decalee", grille: "grille", lignes: "lignes", damier: "damier-love",
      "damier-love": "damier-love", coeur: "coeur", heart: "coeur",
      pleinbord: "plein-bord", "plein-bord": "plein-bord", nombre: "nombre", number: "nombre",
      lettres: "lettres", mot: "lettres", word: "lettres",
      manuscrit: "manuscrit", "mot-manuscrit": "manuscrit" };
    if (ALIAS[vise] === "plein-bord") { etat.gabarit = "decalee"; etat.decaleeStyle = "plein-bord"; }
    else if (ALIAS[vise] === "manuscrit") { etat.gabarit = "decalee"; etat.decaleeStyle = "manuscrit"; }
    else if (ALIAS[vise]) etat.gabarit = ALIAS[vise];
    var nUrl = (qs.get("nombre") || "").replace(/\D/g, "").slice(0, 2);
    if (nUrl) { etat.nombre = nUrl; if (ALIAS[vise] == null) etat.gabarit = "nombre"; }
    /* ?titre= renomme la fiche à l'écran. Une carte de collection qui annonce « Cœur de photos »
       doit ouvrir une page qui porte ce nom, sinon le client croit s'être trompé de lien.
       ⛔ LE TITRE N'EST QU'AFFICHÉ. Il ne touche ni le produit, ni la variante, ni la ligne de
       panier : ce qui est vendu reste l'affiche pêle-mêle, et le prix avec. Écrit en texte,
       jamais en HTML, et plafonné : il vient de l'URL, donc de n'importe qui. */
    var titreUrl = (qs.get("titre") || qs.get("title") || "").replace(/[<>]/g, "").trim().slice(0, 70);
    if (titreUrl) {
      var h1 = document.getElementById("pdp-title");
      if (h1) h1.textContent = titreUrl;
      try { document.title = titreUrl + document.title.slice(document.title.indexOf(" \u2013")); } catch (e2) {}
    }
  } catch (e) {}
  function persiste() {
    try {
      var ph = photos.every(function (p) { return p.distant; })
        ? photos.map(function (p) { return p.distant; }) : null;
      sessionStorage.setItem(CLE_SESSION, JSON.stringify({
        g: etat.gabarit, n: etat.nombre, s: etat.texteStyle, k: etat.comptes, t: etat.textes,
        p: etat.police, f: etat.fond, ec: etat.encres, pc: etat.polices,
        cs: etat.coeurStyle, ds: etat.decaleeStyle,
        ph: ph, ma: manuel, ca: cadrage
      }));
    } catch (e) {}
  }
  var photos = [];        // { bmp, w, h, url (objectURL), fichier }
  var manuel = {};        // par case : index photo choisi, null = retirée, absent = auto
  var cadrage = {};       // par case : { dx, dy, z } (0..1, 0..1, 1..3)
  var selection = -1;
  var occupe = false;

  /* Photos d'exemple : filigrane des cases tant que rien n'est importé. Jamais dans
     le fichier d'impression (l'ajout au panier exige au moins une photo). */
  var demos = [];
  (window.__pdpPeleMeleDemos || []).forEach(function (u, i) {
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () { demos[i] = { bmp: img, w: img.naturalWidth, h: img.naturalHeight }; planifie(); };
    img.src = u;
  });
  function demosCharges() { return demos.filter(Boolean); }

  var CHAMPS_COEUR = {
    bandes: [{ cle: "legende", defaut: T.amour || "LOVE", max: 24 },
             { cle: "noms", defaut: "", ph: "CAMILLE & LUCA", max: 32 }],
    posee: [{ cle: "legende", defaut: T.amour || "LOVE", max: 24 },
            { cle: "citation", defaut: T.d_citation || "", max: 120 }],
    couronne: [{ cle: "legende", defaut: T.amour || "LOVE", max: 24 },
               { cle: "citation", defaut: T.d_citation || "", max: 120 }],
    diagonales: [{ cle: "titre", defaut: T.d_ensemble || "TOGETHER", max: 20 },
                 { cle: "noms", defaut: "", ph: "CAMILLE & LUCA", max: 32 },
                 { cle: "sous", defaut: T.d_sous || "YOU AND ME", max: 32 },
                 { cle: "para", defaut: T.d_para || "", max: 160 }]
  };
  function coeurStyle() {
    /* L'ancien style découpait le cœur comme « Grandes photos », en plus petit :
       deux styles pour un seul résultat. Il devient « Petites photos », où chaque
       photo reste entière (Adrien, 03/08/2026). Les sessions et les liens qui
       portent l'ancien nom arrivent sur le nouveau style. */
    var st = etat.coeurStyle === "mosaique" ? "posee" : etat.coeurStyle;
    return CHAMPS_COEUR[st] ? st : "bandes";
  }
  function decaleeStyle() {
    return CHAMPS_DECALEE[etat.decaleeStyle] ? etat.decaleeStyle : "decalee";
  }
  function estPleinBord() {
    return etat.gabarit === "decalee" && decaleeStyle() === "plein-bord";
  }
  function estManuscrit() {
    return etat.gabarit === "decalee" && decaleeStyle() === "manuscrit";
  }
  /* Clé du nombre de cases : le plein bord garde son propre compte, ses limites
     et son pas, comme du temps où il était une mise en page à part. */
  /* ⛔ UN STYLE QUI CHANGE LE NOMBRE DE CASES A SA PROPRE CLÉ. Sans elle, passer de la
     grille décalée au mot manuscrit garderait un compte impair, que sa géométrie à deux
     colonnes ne sait pas répartir. Même raison que pour plein bord. */
  function cleCompte() { return estPleinBord() ? "plein-bord" : estManuscrit() ? "manuscrit" : etat.gabarit; }
  function champsGabarit() {
    var gb = gabarit();
    if (gb.id === "grille") return CHAMPS_GRILLE[etat.texteStyle] || [];
    if (gb.id === "coeur") return CHAMPS_COEUR[coeurStyle()];
    if (gb.id === "decalee") return CHAMPS_DECALEE[decaleeStyle()] || [];
    return gb.textes || [];
  }
  function valeurTexte(cle) {
    /* ⛔ LE MASQUAGE SE FAIT ICI, POINT UNIQUE DE LECTURE. Tout ce qui dessine passe par cette
       fonction : l'apercu, la mise en situation et le fichier d'impression. Rendre la chaine
       vide suffit donc a retirer le texte PARTOUT, et il n'y a pas un second endroit a penser.
       Masquer dans le dessin aurait laisse le texte partir au tirage. */
    if ((etat.textes[etat.gabarit] || {})[cle + "__masque"]) return "";
    var t = (etat.textes[etat.gabarit] || {})[cle];
    if (t != null && String(t).trim() !== "") return String(t);
    var champ = champsGabarit().filter(function (c) { return c.cle === cle; })[0];
    return champ ? champ.defaut : "";
  }
  function nombreActuel() {
    var n = String(etat.nombre == null ? "" : etat.nombre).replace(/\D/g, "").slice(0, 2);
    return n === "" ? "30" : n;
  }
  function compte(gid) {
    var lim = COMPTES_LIM[gid];
    if (!lim) return 0;
    var v = parseInt(String(etat.comptes[gid] == null ? "" : etat.comptes[gid]).replace(/\D/g, ""), 10);
    /* Sans texte, la grille par defaut fait 15 cases, 16 avec un texte
       (Adrien, 03/08/2026). Un compte choisi au stepper reste tel quel. */
    if (!v) v = gid === "grille" && etat.texteStyle === "sans" ? 15 : COMPTES_DEF[gid];
    v = Math.max(lim[0], Math.min(lim[1], v));
    if (lim[2] === 2) v = Math.round(v / 2) * 2;
    return Math.max(lim[0], Math.min(lim[1], v));
  }
  function lettresDamier() {
    /* 8 lettres : SZERELEM (hongrois) ne rentrait pas en 6 et tombait sur LOVE
       (Adrien, 03/08/2026). */
    var mot = valeurTexte("lettres").toUpperCase().replace(/\s/g, "").slice(0, 8);
    return mot.length >= 2 ? mot : (T.amour || "LOVE");
  }

  /* ---- Style de l'affiche : police, fond, encre (sur le modèle perso) ----
     Police et encre : null = automatique, chaque gabarit garde ses polices et ses
     couleurs de dessin. Une valeur choisie s'applique à TOUS les textes. Sur fond
     sombre, l'encre automatique passe en clair (veille de contraste, comme perso). */
  var POLICES = {
    classic: 'Georgia,"Times New Roman",serif',
    modern: "Arial,Helvetica,sans-serif",
    elegant: 'Palatino,"Palatino Linotype",Georgia,serif',
    bold: 'Impact,"Arial Narrow",Arial,sans-serif',
    script: '"Great Vibes","Apple Chancery",cursive',
    marcellus: "Marcellus,serif",
    garamond: '"Cormorant Garamond",Garamond,serif',
    cinzel: "Cinzel,serif"
  };
  /* ⛔ LE NUMERO SE PREND SUR LES BOUTONS, PAS SUR LA TABLE (Adrien, 16/08/2026 : « ajouter
     entre parentheses la position de la police (1 a 8) pour que je vois a quoi ca correspond »).
     Le client ne lit jamais le mot « modern » : les huit boutons n'affichent qu'un « Aa » dessine
     dans la police elle-meme. Le seul reperage possible est donc le RANG a l'ecran, et ce rang
     est celui du DOM. Le deduire de l'ordre des cles de `POLICES` ferait une deuxieme liste, qui
     resterait juste jusqu'au jour ou l'une des deux bouge : le depot connait deja cette panne,
     « deux listes qui divergent font qu'un meme fichier est trouve par un chemin et pas par
     l'autre » (prefixes-minio.js). Ici la liste de reference est celle qu'Adrien a sous les yeux.
     ⚠️ REPLI SUR LA TABLE si les boutons ne sont pas dans le document : mieux vaut un numero
     tire de l'ordre de declaration qu'aucun numero du tout. */
  function rangPolice(cle) {
    if (!cle) return 0;
    var boutons = document.querySelectorAll("[data-pelemele-police]");
    for (var i = 0; i < boutons.length; i += 1) {
      if (boutons[i].getAttribute("data-pelemele-police") === cle) return i + 1;
    }
    var cles = Object.keys(POLICES);
    var j = cles.indexOf(cle);
    return j < 0 ? 0 : j + 1;
  }
  var MATS = { blanc: "#FFFFFF", creme: "#F5EFE3", sable: "#E8DFD0", sauge: "#C9D2C0",
    poudre: "#E8D3CE", brume: "#CBD5DC", terracotta: "#C67B5C", ocre: "#C8A96B",
    lilas: "#D8D0E4", foret: "#31473A", marine: "#26334D", noir: "#1A1A1A" };
  function fondHex() {
    /* Plein bord : pas de couleur de fond, les photos vont jusqu'au bord et les
       gouttières restent blanches (Adrien, 03/08/2026). */
    if (estPleinBord()) return "#FFFFFF";
    return MATS[etat.fond] || "#FFFFFF";
  }
  function fondSombre() {
    var h = fondHex();
    var r = parseInt(h.slice(1, 3), 16), g = parseInt(h.slice(3, 5), 16), b = parseInt(h.slice(5, 7), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
  }
  function melange(hex, delta) {
    function c(i) { return Math.max(0, Math.min(255, parseInt(hex.slice(i, i + 2), 16) + delta)); }
    return "#" + [c(1), c(3), c(5)].map(function (v) { return ("0" + v.toString(16)).slice(-2); }).join("");
  }
  /* Encre PAR CHAMP, comme la perso : pastille à droite de chaque champ de texte
     (Adrien, 03/08/2026). Sans choix, l'encre du dessin s'applique et passe en
     clair sur fond sombre. */
  function encreDuChamp(cle) { return (etat.encres[etat.gabarit] || {})[cle] || null; }
  function encreChamp(cle, defaut) {
    var choix = encreDuChamp(cle);
    if (choix && MATS[choix]) return MATS[choix];
    return fondSombre() ? "#F5EFE3" : defaut;
  }
  /* ⛔ UNE POLICE PAR TEXTE, MEME CASCADE QUE L'ENCRE (Adrien, 20/08/2026) : celle du champ si
     elle existe, sinon celle de la planche, sinon la famille voulue par le gabarit. Un champ
     sans choix suit donc le selecteur global, et qui ne touche a rien ne voit aucune difference.
     ⚠️ LA CLE EST LE DERNIER ARGUMENT, ET ELLE EST FACULTATIVE : les appels qui ne nomment aucun
     champ (le mot du damier, qui EST le dessin) gardent le comportement d'avant. */
  /* ⛔ LA TAILLE OPTIQUE, PAS LA TAILLE NOMINALE (Adrien, 20/08/2026 : « les polices ne sont
     toujours pas a la meme taille », capture de la LEGENDE sur l'affiche). Une taille en pixels
     ne dit rien de ce qu'on voit : a 30 px, l'anglaise ecrit une ligne deux fois plus basse que
     le serif, parce que son oeil vaut 5,4 px la ou celui de Georgia en vaut 7,2. Le client change
     de police et croit avoir change de corps.
     ⛔ LE FACTEUR SE LIT DANS LA FEUILLE, IL NE SE RECOPIE PAS. `--police-corr` porte deja la
     correction mesuree pour les pastilles ; en ecrire une seconde ici, ce serait deux tables pour
     une seule regle, et c'est celle qu'on ne regarde pas qui vieillit. La lecture est mise en
     cache : `getComputedStyle` dans une boucle de dessin se paierait a chaque lettre.
     ⚠️ CECI CHANGE LE FICHIER D'IMPRESSION, et c'est voulu : l'apercu et le tirage sortent de la
     meme fonction, et c'est toute la garantie du produit. */
  var CORR_CACHE = {};
  function correctionOptique(nom) {
    if (!nom) return 1;
    if (CORR_CACHE[nom] != null) return CORR_CACHE[nom];
    var v = 1;
    try {
      var b = document.querySelector('[data-pelemele-police="' + nom + '"]');
      if (b) {
        var lu = parseFloat(getComputedStyle(b).getPropertyValue("--police-corr"));
        if (isFinite(lu) && lu > 0) v = lu;
      }
    } catch (e) { v = 1; }
    CORR_CACHE[nom] = v;
    return v;
  }
  function fonte(graisse, taille, familleDefaut, style, cle) {
    var nom = (cle && etat.polices[cle]) || etat.police || "";
    var propre = cle && etat.polices[cle] && POLICES[etat.polices[cle]];
    var fam = propre || (etat.police && POLICES[etat.police] ? POLICES[etat.police] : familleDefaut);
    var t = POLICES[nom] ? taille * correctionOptique(nom) : taille;
    return (style ? style + " " : "") + graisse + " " + t + "px " + fam;
  }

  /* ---- Géométries paramétriques (fractions [x, y, w, h] de la feuille) ---- */

  /* Grille décalée : 2 colonnes de n/2 cases, hauteurs alternées (1,18u / 0,82u),
     la colonne droite commence par la petite : les bords s'entrecroisent. */
  /* Le mot manuscrit : mêmes deux colonnes décalées, mais SERRÉES et à fond perdu. La grille
     décalée ordinaire garde 6 % de marge à gauche, 5 % en haut et une gouttière de 0,7 % ;
     ici les photos touchent les bords et ne laissent qu'un bandeau en bas, celui de la légende
     et des coordonnées. C'est ce qui permet au mot posé par-dessus de mordre sur plusieurs
     cases : sur une grille à marges, il flotterait dans le blanc au lieu de traverser. */
  function geometrieManuscrit(n) {
    var rangs = Math.max(2, Math.round(n / 2)), GUT = 0.005;
    var H = 0.879;
    var u = (H - (rangs - 1) * GUT) / rangs;
    var w = (1 - GUT) / 2;
    function colonne(x, premier) {
      var facteurs = [], somme = 0, i;
      for (i = 0; i < rangs; i++) { var f = (i % 2 === 0) === premier ? 1.16 : 0.84; facteurs.push(f); somme += f; }
      var cellules = [], y = 0;
      for (i = 0; i < rangs; i++) {
        var h = facteurs[i] * u * rangs / somme;
        cellules.push([x, y, w, h]);
        y += h + GUT;
      }
      return cellules;
    }
    var gauche = colonne(0, true), droite = colonne(w + GUT, false);
    var cases = [];
    for (var r = 0; r < rangs; r++) { cases.push(gauche[r]); cases.push(droite[r]); }
    return cases;
  }
  function geometrieDecalee(n) {
    var rangs = n / 2, GUTH = 0.007;
    var Y0 = 0.05, H = 0.81;
    var u = (H - (rangs - 1) * GUTH) / rangs;
    function colonne(x, premier) {
      var facteurs = [], somme = 0, i;
      for (i = 0; i < rangs; i++) { var f = (i % 2 === 0) === premier ? 1.18 : 0.82; facteurs.push(f); somme += f; }
      var cellules = [], y = Y0;
      for (i = 0; i < rangs; i++) {
        var h = facteurs[i] * u * rangs / somme;
        cellules.push([x, y, 0.455, h]);
        y += h + GUTH;
      }
      return cellules;
    }
    /* ⛔ MARGE LATERALE A 4 %, PAS 6 (Adrien, serie 323 : « reduis la largeur des passe partout
       dans pele mele aussi »). Le passe-partout du pele-mele n'est pas un element du gabarit :
       c'est l'espace que les cases laissent au fond de la planche, donc il se regle ICI, en
       fractions de feuille. Comptabilite de la ligne : 0,04 + 0,455 + 0,01 de gouttiere + 0,455
       + 0,04 = 1. La colonne droite garde son x a 0,505, seule la largeur des cases change.
       ⚠️ LA MARGE HAUTE NE BOUGE PAS. Y0 vaut 0,05 et H 0,81 : ce qui reste sous les cases porte
       la legende et les coordonnees. Elargir par le haut prendrait sur ce bandeau, alors que la
       demande porte sur la LARGEUR. */
    var gauche = colonne(0.04, true), droite = colonne(0.505, false);
    var cases = [];
    for (var r = 0; r < rangs; r++) { cases.push(gauche[r]); cases.push(droite[r]); }
    return cases;
  }

  /* Lignes : des bandes pleine largeur empilées. Une seule photo par rang, donc chacune
     garde toute la largeur de l'affiche et se lit de loin. C'est le gabarit le plus simple
     du lot, et le seul dont la hauteur de case suit le NOMBRE : deux bandes donnent deux
     paysages, huit donnent des frises. Mêmes marges que la grande grille, pour que les deux
     gabarits se ressemblent quand on passe de l'un à l'autre. */
  /* ⛔ 5 % DE MARGE LATERALE, CONTRE 8 AVANT (serie 323, meme demande que la grille decalee).
     `LARG` et `X0` vont par paire : 0,05 + 0,90 + 0,05 = 1. Changer l'un sans l'autre decentre
     la planche au lieu de l'elargir, et rien ne le signale puisque les deux gabarits restent
     dessinables. La grande grille porte les memes valeurs, a dessein : le commentaire d'origine
     demande que les deux se ressemblent quand on passe de l'un a l'autre. */
  function geometrieLignes(n) {
    var GUT = 0.011, LARG = 0.90, X0 = 0.05, Y0 = 0.055, yBas = 0.945;
    var H = yBas - Y0;
    var h = (H - (n - 1) * GUT) / n;
    var cases = [], y = Y0;
    for (var i = 0; i < n; i++) { cases.push([X0, y, LARG, h]); y += h + GUT; }
    return cases;
  }

  /* Grande grille : n carrés répartis au plus grand côté possible dans la zone
     laissée par le style de texte ; dernier rang incomplet centré. */
  function geometrieGrille(n, style) {
    /* Memes 5 % que `geometrieLignes` : voir le commentaire pose la-bas (serie 323). */
    var GUT = 0.011, LARG = 0.90, X0 = 0.05;
    var yHaut, yBas;
    if (style === "filets") { yHaut = 0.235; yBas = 0.945; }
    else if (style === "lettres") { yHaut = 0.200; yBas = 0.725; }
    else { yHaut = 0.055; yBas = 0.945; }
    var H = yBas - yHaut;
    var meilleur = null;
    for (var cols = 1; cols <= 10; cols++) {
      var rangs = Math.ceil(n / cols);
      var parLargeur = (LARG - GUT * (cols - 1)) / cols;
      var parHauteur = (H / RATIO - GUT * (rangs - 1)) / rangs;
      var cote = Math.min(parLargeur, parHauteur);
      if (cote <= 0) continue;
      if (!meilleur || cote > meilleur.cote + 1e-9) meilleur = { cols: cols, rangs: rangs, cote: cote };
    }
    var cols2 = meilleur.cols, rangs2 = meilleur.rangs, cote2 = meilleur.cote;
    var bw = cols2 * cote2 + (cols2 - 1) * GUT;
    var bh = (rangs2 * cote2 + (rangs2 - 1) * GUT) * RATIO;
    var x0 = X0 + (LARG - bw) / 2, y0 = yHaut + (H - bh) / 2;
    var cases = [];
    for (var i = 0; i < n; i++) {
      var r = Math.floor(i / cols2), c = i % cols2;
      var dansRang = r === rangs2 - 1 ? n - cols2 * (rangs2 - 1) : cols2;
      var decal = r === rangs2 - 1 ? (bw - (dansRang * cote2 + (dansRang - 1) * GUT)) / 2 : 0;
      cases.push([x0 + decal + c * (cote2 + GUT), y0 + r * (cote2 + GUT) * RATIO, cote2, cote2 * RATIO]);
    }
    return cases;
  }

  /* Damier : une rangée par lettre, case lettre et case photo en alternance. */
  var COULEURS_DAMIER = ["#b5654f", "#857b52", "#a9bfc9", "#d9c49a"];
  function geometrieDamier(mot) {
    var rangs = mot.length;
    var GUTW = 0.008, GUTH = 0.008 * RATIO;
    var rowH = (1 - (rangs - 1) * GUTH) / rangs;
    var colW = (1 - GUTW) / 2;
    var photosC = [], lettres = [];
    for (var r = 0; r < rangs; r++) {
      var y = r * (rowH + GUTH);
      var photoDroite = r % 2 === 0;
      photosC.push([photoDroite ? colW + GUTW : 0, y, colW, rowH]);
      lettres.push({ x: photoDroite ? 0 : colW + GUTW, y: y, w: colW, h: rowH,
        lettre: mot[r], couleur: COULEURS_DAMIER[r % COULEURS_DAMIER.length] });
    }
    return { photos: photosC, lettres: lettres };
  }

  /* Plein bord : 2 ou 3 colonnes bord à bord, gouttières UNIFORMES (l'ancien
     5 photos figé laissait des blancs inégaux), hauteurs alternées par colonne. */
  function geometriePleinBord(n) {
    var GUTW = 0.008, GUTH = 0.008 * RATIO;
    var cols = n <= 4 ? 2 : 3;
    var parts = cols === 2 ? [0.54, 0.46] : [0.32, 0.36, 0.32];
    var comptes = [], i;
    for (i = 0; i < cols; i++) comptes.push(Math.floor(n / cols));
    var reste = n - Math.floor(n / cols) * cols;
    var ordre = cols === 3 ? [0, 2, 1] : [0, 1];
    for (i = 0; i < reste; i++) comptes[ordre[i]]++;
    var utile = 1 - GUTW * (cols - 1);
    var cases = [], x = 0;
    for (i = 0; i < cols; i++) {
      var k = comptes[i], w = parts[i] * utile;
      var u = (1 - (k - 1) * GUTH) / k;
      var facteurs = [], somme = 0, j;
      for (j = 0; j < k; j++) { var f = (j % 2 === 0) === (i % 2 === 0) ? 1.25 : 0.85; facteurs.push(f); somme += f; }
      var y = 0;
      for (j = 0; j < k; j++) {
        var h = k === 1 ? 1 : facteurs[j] * u * k / somme;
        cases.push([x, y, w, h]);
        y += h + GUTH;
      }
      x += w + GUTW;
    }
    return cases;
  }

  /* Le cœur en gradins est plus large que haut, comme tous les cœurs en pixels :
     c'est la LARGEUR qui le borne, et il se centre dans la bande laissee libre
     entre la legende du haut et la citation du bas. Chaque palier a son propre
     rapport hauteur/largeur, donc le centrage se recalcule, il ne se code pas. */
  var COEUR_BANDE = { haut: 0.20, bas: 0.80 };
  function geometrieCoeurTuiles(ref, W, H, largeur) {
    var cote = largeur * W;
    var haut = cote * ref.ratio;
    var bande = (COEUR_BANDE.bas - COEUR_BANDE.haut) * H;
    var x = (W - cote) / 2, y = COEUR_BANDE.haut * H + (bande - haut) / 2;
    var tuiles = ref.tuiles.map(function (t) {
      return { cx: x + t.cx * cote, cy: y + t.cy * cote, taille: t.taille * cote };
    });
    return { x: x, y: y, cote: cote, tuiles: tuiles };
  }
  function geometrieCoeurPosee(W, H) {
    return geometrieCoeurTuiles(coeurPoseeRef(), W, H, 0.86);
  }
  /* La couronne est un cœur entier, donc carré (ratio 1) : c'est la HAUTEUR de la
     bande qui la borne, pas la largeur, sinon elle déborderait sur la citation. */
  function geometrieCoeurCouronne(W, H) {
    var bande = (COEUR_BANDE.bas - COEUR_BANDE.haut) * H;
    return geometrieCoeurTuiles(coeurCouronneRef(), W, H, Math.min(0.80, bande / W));
  }
  function geometrieCoeurDiagonales(W, H) {
    var ref = coeurDiagRef();
    var cote = 0.72 * W;
    var x = (W - cote) / 2, y = 0.215 * H;
    var rr = ref.r * cote;
    var losanges = ref.losanges.map(function (t) {
      return {
        cx: x + t.cx * cote, cy: y + t.cy * cote, rr: rr,
        /* Les echardes absorbees voyagent en decalages, mis a l'echelle ici : le
           dessin, le survol et le clic lisent tous les trois la meme geometrie. */
        absorbes: (t.absorbes || []).map(function (d) { return [d[0] * cote, d[1] * cote]; })
      };
    });
    return { x: x, y: y, cote: cote, losanges: losanges };
  }
  /* Les tuiles du nombre et du cœur, en pixels d'écran : servent au survol ET au
     clic (le survol cuivre manquait sur ces gabarits, Adrien, 03/08/2026). */
  function tuilesEcran(W, H) {
    var gb = gabarit();
    if (gb.id === "nombre" || gb.id === "lettres") {
      var calc = gb.id === "lettres" ? calculeLettres(W, H) : calculeNombre(W, H);
      return calc.tuiles.map(function (t) {
        return { x: t.chiffre.x + t.tx, y: t.chiffre.y + t.ty, w: t.tw, h: t.th };
      });
    }
    if (gb.id === "coeur") {
      var st = coeurStyle();
      if (st === "posee" || st === "couronne") {
        var geoT = st === "couronne" ? geometrieCoeurCouronne(W, H) : geometrieCoeurPosee(W, H);
        return geoT.tuiles.map(function (t) {
          return { x: t.cx - t.taille / 2, y: t.cy - t.taille / 2, w: t.taille, h: t.taille };
        });
      }
      if (st === "diagonales") {
        var geoDi = geometrieCoeurDiagonales(W, H);
        return geoDi.losanges.map(function (t) {
          return { diamant: true, cx: t.cx, cy: t.cy, rr: t.rr, absorbes: t.absorbes,
                   coeur: { x: geoDi.x, y: geoDi.y, cote: geoDi.cote } };
        });
      }
      var calcB = calculeCoeur(W, H);
      return calcB.tuiles.map(function (t) {
        return { x: calcB.x + t.tx, y: calcB.y + t.ty, w: t.tw, h: t.th };
      });
    }
    return null;
  }
  function dessineSurvolTuiles(g, W, H, apercu) {
    if (!apercu || survol < 0) return;
    var formes = tuilesEcran(W, H);
    if (!formes || !formes[survol]) return;
    var q = formes[survol];
    g.save();
    g.lineJoin = "round";
    [["#ffffff", Math.max(3, W * 0.008)], ["#B8714C", Math.max(2, W * 0.005)]].forEach(function (traits) {
      g.strokeStyle = traits[0]; g.lineWidth = traits[1];
      if (q.diamant) {
        /* ⛔ LE CONTOUR DE SURVOL EPOUSE CE QUI EST VISIBLE. Une maille de bord est
           decoupee par le coeur : trace en entier, son liseré cuivre debordait dans
           le blanc de l'affiche (Adrien, 03/08/2026). On le clippe donc au coeur, et
           on y ajoute les echardes absorbees, qui font partie de la meme photo. */
        g.save();
        if (q.coeur) {
          g.translate(q.coeur.x, q.coeur.y);
          traceCoeur(g, q.coeur.cote, q.coeur.cote);
          g.clip();
          g.translate(-q.coeur.x, -q.coeur.y);
        }
        g.beginPath();
        var pose = function (cx, cy) {
          g.moveTo(cx, cy - q.rr); g.lineTo(cx + q.rr, cy);
          g.lineTo(cx, cy + q.rr); g.lineTo(cx - q.rr, cy);
          g.closePath();
        };
        pose(q.cx, q.cy);
        (q.absorbes || []).forEach(function (d) { pose(q.cx + d[0], q.cy + d[1]); });
        g.stroke();
        g.restore();
      } else {
        g.strokeRect(q.x + 1.5, q.y + 1.5, q.w - 3, q.h - 3);
      }
    });
    g.restore();
  }
  function casesCourantes() {
    var gb = gabarit();
    if (gb.id === "nombre" || gb.id === "coeur" || gb.id === "lettres") return [];
    if (gb.id === "decalee") {
      if (estPleinBord()) return geometriePleinBord(compte("plein-bord"));
      if (estManuscrit()) return geometrieManuscrit(compte("manuscrit"));
      return geometrieDecalee(compte("decalee"));
    }
    if (gb.id === "grille") return geometrieGrille(compte("grille"), etat.texteStyle);
    if (gb.id === "lignes") return geometrieLignes(compte("lignes"));
    if (gb.id === "damier-love") return geometrieDamier(lettresDamier()).photos;
    return [];
  }

  /* ---- Cœur : même mécanique de masque et de bandes que les chiffres ---- */
  function traceCoeur(g, w, h, creux) {
    /* `creux` = profondeur de l'échancrure. Les styles découpés gardent 0,24 ;
       les photos posées demandent une fente plus large que leurs cases, sinon la
       case du milieu enjambe les deux lobes et le décolleté disparaît
       (Adrien, 03/08/2026). */
    var c = creux == null ? 0.24 : creux;
    g.beginPath();
    g.moveTo(w * 0.5, h * 0.95);
    g.bezierCurveTo(w * -0.22, h * 0.58, w * 0.08, h * -0.13, w * 0.5, h * c);
    g.bezierCurveTo(w * 0.92, h * -0.13, w * 1.22, h * 0.58, w * 0.5, h * 0.95);
    g.closePath();
  }
  /* Le nombre d'images du cœur se choisit : on précalcule les découpes à 2, 3, 4
     et 5 rangs et on sert celle dont le compte est le plus proche de la cible. */
  var cachesCoeur = {};
  var CONFIGS_COEUR = [[2, 2], [2, 3], [3, 3], [3, 4], [3, 5]];
  function coeurComptesDisponibles() {
    /* Chaque style du coeur a ses propres paliers : configs de bandes, densites
       de photos posees, diviseurs de losanges (Adrien, 03/08/2026). */
    var st = coeurStyle(), vus = {};
    if (st === "posee") POSEE_DENSITES.forEach(function (n) { vus[coeurPoseeBase(n).total] = true; });
    else if (st === "couronne") COURONNE_COMPTES.forEach(function (n) { vus[n] = true; });
    else if (st === "diagonales") DIAG_DIVISEURS.forEach(function (d) { vus[coeurDiagBase(d).total] = true; });
    else CONFIGS_COEUR.forEach(function (cfg) { vus[coeurBandes(cfg[0], cfg[1]).total] = true; });
    return Object.keys(vus).map(Number).sort(function (a, b) { return a - b; });
  }
  function coeurRef() {
    /* 2 colonnes pour les petits comptes, 3 pour les grands : a 2 colonnes la
       fusion plafonnait vers 6 photos et 10 rendait comme 6. */
    var cible = compte("coeur"), meilleur = null;
    CONFIGS_COEUR.forEach(function (cfg) {
      var c = coeurBandes(cfg[0], cfg[1]);
      if (!meilleur || Math.abs(c.total - cible) < Math.abs(meilleur.total - cible)) meilleur = c;
    });
    return meilleur;
  }
  function coeurBandes(COLS, RANGS) {
    var cleCache = COLS + "x" + RANGS;
    if (cachesCoeur[cleCache]) return cachesCoeur[cleCache];
    var REF = 600, SEUIL = 0.22;
    var masque = document.createElement("canvas");
    masque.width = REF; masque.height = REF;
    var mg = masque.getContext("2d");
    traceCoeur(mg, REF, REF);
    mg.fill();
    var alpha = null;
    try { alpha = mg.getImageData(0, 0, REF, REF).data; } catch (e) {}
    function couvre(px, py) {
      if (!alpha) return true;
      var ix = Math.max(0, Math.min(REF - 1, Math.round(px)));
      var iy = Math.max(0, Math.min(REF - 1, Math.round(py)));
      return alpha[(iy * REF + ix) * 4 + 3] > 16;
    }
    var cw = REF / COLS, chh = REF / RANGS;
    var bandes = [], total = 0;
    for (var cx = 0; cx < COLS; cx++) {
      var segs = [];
      for (var ry = 0; ry < RANGS; ry++) {
        var hits = 0;
        for (var sy = 0; sy < 5; sy++) for (var sx = 0; sx < 5; sx++) {
          if (couvre(cx * cw + cw * (sx + 0.5) / 5, ry * chh + chh * (sy + 0.5) / 5)) hits++;
        }
        segs.push({ y0: ry, y1: ry + 1, hits: hits, echant: 25 });
      }
      var encore = true;
      while (encore && segs.length > 1) {
        encore = false;
        for (var si = 0; si < segs.length; si++) {
          var cov = segs[si].hits / segs[si].echant;
          if (cov >= 0.02 && cov < SEUIL) {
            var avant = si > 0 ? segs[si - 1] : null;
            var apres = si < segs.length - 1 ? segs[si + 1] : null;
            var cible = avant && apres
              ? (avant.hits / avant.echant >= apres.hits / apres.echant ? avant : apres)
              : (avant || apres);
            cible.y0 = Math.min(cible.y0, segs[si].y0);
            cible.y1 = Math.max(cible.y1, segs[si].y1);
            cible.hits += segs[si].hits; cible.echant += segs[si].echant;
            segs.splice(si, 1);
            encore = true;
            break;
          }
        }
      }
      segs.forEach(function (sgm) {
        if (sgm.hits / sgm.echant < 0.02) return;
        bandes.push({ cx: cx, y0: sgm.y0 / RANGS, y1: sgm.y1 / RANGS });
        total++;
      });
    }
    cachesCoeur[cleCache] = { bandes: bandes, total: total, cols: COLS };
    return cachesCoeur[cleCache];
  }
  /* ⛔ COEUR EN PETITES PHOTOS POSEES. Chaque photo reste un RECTANGLE ENTIER,
     avec sa gouttière : c'est l'arrangement qui dessine le cœur, pas un masque.
     Les cases du bord, moins couvertes, sont plus petites, donc la silhouette
     s'adoucit sans jamais couper une photo (Adrien, 03/08/2026).
     Diagonales : losanges à photos droites. */
  var cachesCoeurPosee = {};
  /* ⛔ LE CŒUR SE DESSINE, IL NE SE DEDUIT PAS D'UN TRACE. Deux approches ont
     echoue avant celle-ci, chacune sur plusieurs paliers d'affilee : echantillonner
     une grille carree sous un masque de cœur (losange en escalier), puis mesurer
     les segments du cœur ligne par ligne et y centrer des cases (le decollete
     disparaissait des que le nombre baissait). Adrien a recale les deux, puis a
     valide celle-ci sur maquettes le 03/08/2026.

     Ici la forme est ECRITE : une table par palier, une chaine par rangee, un X
     par photo. L'echancrure du haut et la pointe du bas sont donc POSEES, elles ne
     dependent plus d'un calcul qui peut mal tomber. C'est la construction des
     cœurs en pixels, et c'est la seule qui se lise encore a 20 photos.

     Toute nouvelle table doit garder : deux lobes separes par UNE colonne vide,
     une seule photo sur la derniere rangee, et un nombre de colonnes IMPAIR sans
     quoi il n'y a pas de pointe. */
  var TABLES_COEUR = {
    20: [".XX.XX.",
         "XXXXXXX",
         ".XXXXX.",
         "..XXX..",
         "...X..."],
    27: [".XX.XX.",
         "XXXXXXX",
         "XXXXXXX",
         ".XXXXX.",
         "..XXX..",
         "...X..."],
    40: [".XXX.XXX.",
         "XXXXXXXXX",
         "XXXXXXXXX",
         ".XXXXXXX.",
         "..XXXXX..",
         "...XXX...",
         "....X...."],
    55: [".XXXX.XXXX.",
         "XXXXXXXXXXX",
         "XXXXXXXXXXX",
         ".XXXXXXXXX.",
         "..XXXXXXX..",
         "...XXXXX...",
         "....XXX....",
         ".....X....."]
  };
  var POSEE_DENSITES = [20, 27, 40, 55];
  /* Les cases sont CARREES : `cx` et `cy` se comptent tous les deux en largeurs de
     case, donc `cy` monte jusqu'a `ratio` et non jusqu'a 1. Rapporter le rang au
     nombre de rangs etirerait le cœur verticalement, ce qui redonne un losange. */
  function coeurPoseeBase(cle) {
    if (cachesCoeurPosee[cle]) return cachesCoeurPosee[cle];
    var table = TABLES_COEUR[cle], cols = table[0].length, rangs = table.length;
    var pas = 1 / cols, tuiles = [];
    for (var r = 0; r < rangs; r++) {
      for (var c = 0; c < cols; c++) {
        if (table[r].charAt(c) !== "X") continue;
        tuiles.push({ cx: (c + 0.5) * pas, cy: (r + 0.5) * pas, taille: pas * 0.90 });
      }
    }
    cachesCoeurPosee[cle] = { tuiles: tuiles, total: tuiles.length, ratio: rangs / cols };
    return cachesCoeurPosee[cle];
  }
  function coeurPoseeRef() {
    var cible = etat.comptes.coeur == null ? 27 : compte("coeur"), meilleur = null;
    POSEE_DENSITES.forEach(function (n) {
      var c = coeurPoseeBase(n);
      if (!meilleur || Math.abs(c.total - cible) < Math.abs(meilleur.total - cible)) meilleur = c;
    });
    return meilleur;
  }

  /* La COURONNE : les photos suivent le contour, le centre reste vide. C'est la
     silhouette elle-même qui est dessinée par les photos, donc elle se lit du
     premier coup d'œil, même à quatorze photos.

     ⛔ PAS DE GRANDS NOMBRES ICI (Adrien, 03/08/2026). Le périmètre est fixe :
     plus on ajoute de photos, plus chacune rétrécit, et au-delà d'une trentaine
     la couronne devient un liseré de vignettes illisibles. Les paliers s'arrêtent
     donc à 30, là où les autres styles montent à 55. */
  var COURONNE_COMPTES = [14, 18, 24, 30];
  var cacheCouronne = {};
  function coeurCouronneBase(n) {
    if (cacheCouronne[n]) return cacheCouronne[n];
    /* Le contour se relève sur les deux béziers de traceCoeur, échantillonnés fin,
       puis se parcourt à PAS D'ARC CONSTANT : réparties sur le paramètre t, les
       photos s'entassent dans les courbures et s'espacent sur les droites. */
    var REF = 1, N = 1200;
    function bez(p0, p1, p2, p3, t) {
      var u = 1 - t;
      return u * u * u * p0 + 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t * p3;
    }
    var courbes = [
      [[0.50, 0.95], [-0.22, 0.58], [0.08, -0.13], [0.50, 0.24]],
      [[0.50, 0.24], [0.92, -0.13], [1.22, 0.58], [0.50, 0.95]]
    ];
    var pts = [];
    courbes.forEach(function (c) {
      for (var i = 0; i <= N; i++) {
        var t = i / N;
        pts.push([bez(c[0][0], c[1][0], c[2][0], c[3][0], t) * REF,
                  bez(c[0][1], c[1][1], c[2][1], c[3][1], t) * REF]);
      }
    });
    var cumul = [0];
    for (var i = 1; i < pts.length; i++) {
      cumul.push(cumul[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    }
    var perimetre = cumul[cumul.length - 1];
    /* Les photos se touchent presque : un pas de plus et la couronne se troue, un
       pas de moins et elles s'empilent. 1,05 laisse un chevauchement discret qui
       ferme le trait. */
    var taille = Math.min(0.30, (perimetre / n) * 1.05);
    var tuiles = [], j = 0;
    for (var k = 0; k < n; k++) {
      var vise = perimetre * k / n;
      while (j < cumul.length - 1 && cumul[j] < vise) j++;
      tuiles.push({ cx: pts[j][0], cy: pts[j][1], taille: taille });
    }
    /* ⛔ ON CALE SUR L'EMPRISE DES PHOTOS, PAS SUR LA BOITE DU TRACE. Le tracé
       laisse 14 % de vide au-dessus des lobes et déborde de 5 % sous la pointe :
       cadré sur lui, le cœur s'affichait haut dans l'affiche avec un blanc en bas.
       Ici on mesure les photos elles-mêmes, bords compris, et le rapport rendu est
       celui de ce qu'on voit. */
    var demi = taille / 2;
    var x0 = Math.min.apply(null, tuiles.map(function (t) { return t.cx - demi; }));
    var x1 = Math.max.apply(null, tuiles.map(function (t) { return t.cx + demi; }));
    var y0 = Math.min.apply(null, tuiles.map(function (t) { return t.cy - demi; }));
    var y1 = Math.max.apply(null, tuiles.map(function (t) { return t.cy + demi; }));
    var k2 = 1 / (x1 - x0);
    tuiles = tuiles.map(function (t) {
      return { cx: (t.cx - x0) * k2, cy: (t.cy - y0) * k2, taille: taille * k2 };
    });
    cacheCouronne[n] = { tuiles: tuiles, total: n, ratio: (y1 - y0) * k2 };
    return cacheCouronne[n];
  }
  function coeurCouronneRef() {
    var cible = etat.comptes.coeur == null ? 18 : compte("coeur"), meilleur = null;
    COURONNE_COMPTES.forEach(function (n) {
      var c = coeurCouronneBase(n);
      if (!meilleur || Math.abs(c.total - cible) < Math.abs(meilleur.total - cible)) meilleur = c;
    });
    return meilleur;
  }
  var cacheCoeurDiag = {};
  /* Les paliers montent maintenant a 11 : le seuil d'echarde retire des cases, et
     sans divisions plus fines le haut de gamme serait tombe de 28 a 21 photos. */
  var DIAG_DIVISEURS = [4, 5, 6, 7, 8, 9, 10, 11];
  function coeurDiagBase(D) {
    if (cacheCoeurDiag[D]) return cacheCoeurDiag[D];
    var REF = 600;
    var masque = document.createElement("canvas");
    masque.width = REF; masque.height = REF;
    var mg = masque.getContext("2d");
    traceCoeur(mg, REF, REF);
    mg.fill();
    var alpha = null;
    try { alpha = mg.getImageData(0, 0, REF, REF).data; } catch (e) {}
    function couvre(px, py) {
      if (!alpha) return true;
      var ix = Math.max(0, Math.min(REF - 1, Math.round(px)));
      var iy = Math.max(0, Math.min(REF - 1, Math.round(py)));
      return alpha[(iy * REF + ix) * 4 + 3] > 16;
    }
    /* Treillis de losanges : centres espaces d'un rayon, une maille sur deux.

       ⛔ UNE ECHARDE N'EST PAS UNE PHOTO. Garder tout losange qui TOUCHE le coeur
       revenait a vendre des cases couvertes a 1 % : des eclats de photo sur le
       bord, illisibles, et un contour de survol dessine ENTIEREMENT HORS du coeur
       puisque le centre de la maille est dehors (Adrien, 03/08/2026, captures a 14
       cases). L'ancien test s'arretait au premier point trouve, il ne mesurait
       donc rien : il repondait oui ou non, jamais combien.

       Ici on mesure la part reellement DANS le coeur. Au-dessus du seuil, la maille
       est une photo. En dessous, elle est ABSORBEE par sa voisine la mieux couverte,
       qui s'etend dessus : le contour du coeur reste plein, sans case inutile. */
    var SEUIL = 0.25;
    var r = REF / D, grille = {}, cellules = [];
    for (var i = -D; i <= 2 * D; i++) for (var j = -D; j <= 2 * D; j++) {
      if ((i + j) % 2 !== 0) continue;
      var cx = i * r, cy = j * r;
      if (cx < -r || cx > REF + r || cy < -r || cy > REF + r) continue;
      var dans = 0, echant = 0;
      for (var sy = 0; sy < 15; sy++) for (var sx = 0; sx < 15; sx++) {
        var px = cx - r + r * 2 * (sx + 0.5) / 15, py = cy - r + r * 2 * (sy + 0.5) / 15;
        if (Math.abs(px - cx) + Math.abs(py - cy) > r) continue;
        echant++;
        if (couvre(px, py)) dans++;
      }
      if (!dans) continue;
      var cel = { i: i, j: j, couv: dans / echant, garde: dans / echant >= SEUIL, absorbes: [] };
      grille[i + ":" + j] = cel;
      cellules.push(cel);
    }
    /* Les quatre voisines du treillis sont en diagonale : elles partagent une ARETE
       entiere avec la maille, c'est ce qui permet a l'une de couvrir l'autre sans
       trou. On rattache l'echarde a la mieux couverte ; sans voisine gardee, elle
       disparait, et a moins d'un quart de couverture cela ne se voit pas. */
    cellules.forEach(function (c) {
      if (c.garde) return;
      var meilleure = null;
      [[1, 1], [1, -1], [-1, 1], [-1, -1]].forEach(function (d) {
        var v = grille[(c.i + d[0]) + ":" + (c.j + d[1])];
        if (v && v.garde && (!meilleure || v.couv > meilleure.couv)) meilleure = v;
      });
      if (meilleure) meilleure.absorbes.push([(c.i - meilleure.i) * r / REF, (c.j - meilleure.j) * r / REF]);
    });
    var losanges = cellules.filter(function (c) { return c.garde; }).map(function (c) {
      return { cx: c.i * r / REF, cy: c.j * r / REF, absorbes: c.absorbes };
    });
    cacheCoeurDiag[D] = { losanges: losanges, r: r / REF, total: losanges.length };
    return cacheCoeurDiag[D];
  }
  function coeurDiagRef() {
    var cible = compte("coeur"), meilleur = null;
    DIAG_DIVISEURS.forEach(function (d) {
      var c = coeurDiagBase(d);
      if (!meilleur || Math.abs(c.total - cible) < Math.abs(meilleur.total - cible)) meilleur = c;
    });
    return meilleur;
  }
  function coeurTotal() {
    var st = coeurStyle();
    if (st === "posee") return coeurPoseeRef().total;
    if (st === "couronne") return coeurCouronneRef().total;
    if (st === "diagonales") return coeurDiagRef().total;
    return coeurRef().total;
  }
  function calculeCoeur(W, H, ech) {
    ech = ech || 1;
    var ref = coeurRef();
    /* Grand cœur : presque toute la largeur, remonté pour laisser la place aux
       textes dessous (Adrien, 03/08/2026). */
    var cote = 0.92 * W;
    var x = (W - cote) / 2, y = 0.08 * H;
    var masque = document.createElement("canvas");
    masque.width = Math.ceil(cote * ech); masque.height = Math.ceil(cote * ech);
    var mg = masque.getContext("2d");
    mg.setTransform(ech, 0, 0, ech, 0, 0);
    traceCoeur(mg, cote, cote);
    mg.fill();
    var tw = cote / (ref.cols || 2);
    var tuiles = ref.bandes.map(function (b) {
      return { tx: b.cx * tw, ty: b.y0 * cote, tw: tw, th: (b.y1 - b.y0) * cote };
    });
    return { masque: masque, x: x, y: y, tuiles: tuiles };
  }

  function affectations(total) {
    var n = photos.length, sortie = [], suivant = 0;
    if (total == null) {
      var g = gabarit();
      total = g.id === "nombre" ? nombreRef().total
        : g.id === "lettres" ? lettresRef().total
        : g.id === "coeur" ? coeurTotal()
        : casesCourantes().length;
    }
    /* ⛔ UNE PHOTO = UNE CASE. L'import ne duplique plus la photo dans toute la
       grille (Adrien, 03/08/2026) : les cases au-delà des photos importées
       restent vides et invitent à en ajouter. */
    /* ⛔ Une photo EPINGLEE a une case ne repart pas dans le flux automatique :
       sans ce filtre, remplacer une case dupliquait sa nouvelle photo dans la
       premiere case vide (Adrien, 03/08/2026). */
    var pris = {};
    Object.keys(manuel).forEach(function (k) {
      var vm = manuel[k];
      if (typeof vm === "number" && vm >= 0 && vm < n) pris[vm] = true;
    });
    for (var i = 0; i < total; i++) {
      var m = manuel[i];
      if (m === null) { sortie.push(-1); continue; }
      if (typeof m === "number" && m >= 0 && m < n) { sortie.push(m); continue; }
      while (suivant < n && pris[suivant]) suivant++;
      sortie.push(suivant < n ? suivant++ : -1);
    }
    return sortie;
  }
  function reglage(i) { return cadrage[i] || { dx: 0.5, dy: 0.5, z: 1 }; }

  /* ---- Dessin ---- */
  /* ⛔ RESOLUTION DES TAMPONS. L'aperçu dessine dans un contexte déjà mis à
     l'échelle du DPR : un canvas intermédiaire créé aux dimensions LOGIQUES
     sort deux fois trop petit et remonte crénelé (Adrien, 03/08/2026 : le
     nombre et le cœur pixellisés, la grille et le damier nets car ils dessinent
     droit dans le contexte). Les tampons suivent donc l'échelle réelle du
     contexte et sont collés en unités logiques. À l'impression l'échelle vaut
     1 : le rendu ne change pas. */
  function echelleRendu(g) {
    try {
      var t = g.getTransform ? g.getTransform() : null;
      var e = t ? Math.abs(t.a) : 1;
      return Math.max(1, Math.min(4, e || 1));
    } catch (err) { return 1; }
  }
  /* ⛔ QUALITE DES REDUCTIONS. Un drawImage unique sous 0,5x rend flou et
     cranté (lissage par défaut du canvas) : les photos démo du gabarit nombre
     sortaient baveuses (Adrien, 03/08/2026). Réduction par moitiés successives,
     pyramide calculée UNE fois par photo, puis dessin final entre 0,5x et 1x
     en lissage haute qualité. Vaut pour l'aperçu ET le fichier d'impression. */
  function sourceReduite(p, s) {
    if (s >= 0.5 || !p.bmp) return p;
    var niveau = 0, sc = s;
    while (sc < 0.5 && niveau < 3) { niveau++; sc *= 2; }
    p.mips = p.mips || {};
    if (!p.mips[niveau]) {
      var courant = { bmp: p.bmp, w: p.w, h: p.h };
      for (var e = 0; e < niveau; e++) {
        var c = document.createElement("canvas");
        c.width = Math.max(1, Math.round(courant.w / 2));
        c.height = Math.max(1, Math.round(courant.h / 2));
        var g2 = c.getContext("2d");
        g2.imageSmoothingEnabled = true;
        try { g2.imageSmoothingQuality = "high"; } catch (err) {}
        g2.drawImage(courant.bmp, 0, 0, c.width, c.height);
        courant = { bmp: c, w: c.width, h: c.height };
      }
      p.mips[niveau] = courant;
    }
    return p.mips[niveau];
  }
  function dessinePhoto(g, p, x, y, w, h, r) {
    var s = Math.max(w / p.w, h / p.h) * (r.z || 1);
    var src = sourceReduite(p, s);
    var sEff = Math.max(w / src.w, h / src.h) * (r.z || 1);
    var dw = src.w * sEff, dh = src.h * sEff;
    g.save();
    g.imageSmoothingEnabled = true;
    try { g.imageSmoothingQuality = "high"; } catch (err) {}
    g.beginPath(); g.rect(x, y, w, h); g.clip();
    g.drawImage(src.bmp, x + (w - dw) * r.dx, y + (h - dh) * r.dy, dw, dh);
    g.restore();
  }
  function dessineDemo(g, i, x, y, w, h) {
    /* ⛔ AUCUNE PHOTO D'EXEMPLE DANS L'ATELIER (Adrien, 23/08/2026 : « il n'y a plus d'image
       pre-telechargees en exemple, seulement les "+" sur les carres a remplir »). La FICHE montre
       de vraies photos pour donner envie ; la FENETRE est l'atelier du client, et des visages qui
       ne sont pas les siens y font croire que quelque chose est deja pose.
       ⚠️ ON REND `false` PLUTOT QUE DE NE RIEN DESSINER : chaque appelant a deja un repli qui
       peint le placement vide. Sortir en silence laisserait un trou. */
    if (document.documentElement.classList.contains("pa-ouvert")) return false;
    /* Pleine opacité : le voile faisait paperasse, les modèles montrent de vraies
       photos (Adrien, 03/08/2026). */
    var charges = demosCharges();
    if (!charges.length) return false;
    dessinePhoto(g, charges[i % charges.length], x, y, w, h, { dx: 0.5, dy: 0.5, z: 1 });
    return true;
  }
  /* ⛔ UN PLACEMENT VIDE EST BLANC, ET IL LE RESTE QUAND LE FOND CHANGE (Adrien, 20/08/2026 :
     « pas de transparence derriere les placements. Quand on change de fond ca ne doit pas changer
     la couleur des placements, ils doivent rester blancs »). Ils etaient peints en MELANGE du
     fond, a quelques degres pres : sur un fond sable ils viraient sable, et l'affiche se lisait
     comme un aplat troue plutot que comme des emplacements a remplir.
     ⚠️ ET LA CROIX AVEC : elle basculait au clair sur fond sombre, ce qui la rendrait invisible
     sur un placement desormais blanc. Une seule fonction decide des deux, parce que cinq endroits
     decidaient chacun dans leur coin — c'est ainsi que la regle a derive. */
  var BLANC_PLACEMENT = "#ffffff";
  var TRAIT_PLACEMENT = "#b9b4a9";
  function dessineVide(g, x, y, w, h, apercu, W) {
    g.fillStyle = BLANC_PLACEMENT;
    g.fillRect(x, y, w, h);
    if (!apercu) return;
    /* ⛔⛔ LA LARGEUR DE REFERENCE EST FACULTATIVE. Cette fonction recevait `W`, la largeur de
       l'affiche, pour epaissir la croix a l'echelle du dessin. Le 23/08/2026 je l'ai appelee
       depuis `dessineGlyphes`, qui n'a pas ce parametre : `Can't find variable: W` etait levee a
       chaque clic sur « Nombre » et « Mot en photos », les deux gabarits a glyphes, et le
       gabarit ne s'appliquait pas — le bouton restait eteint et son bloc de saisie masque.
       ⚠️ AUCUNE ERREUR VISIBLE POUR LE CLIENT : le clic ne faisait simplement rien. C'est la
       console qui l'a dit, pas la page. Une fonction qui exige un argument que ses appelants
       n'ont pas tous est une panne qui attend son tour ; le repli la retire. */
    var ref = (typeof W === "number" && W > 0) ? W : Math.max(w, h) * 3;
    var l = Math.min(w, h) * 0.16, ep = Math.max(1.5, ref * 0.004);
    g.strokeStyle = TRAIT_PLACEMENT; g.lineWidth = ep; g.lineCap = "round";
    g.beginPath();
    g.moveTo(x + w / 2 - l, y + h / 2); g.lineTo(x + w / 2 + l, y + h / 2);
    g.moveTo(x + w / 2, y + h / 2 - l); g.lineTo(x + w / 2, y + h / 2 + l);
    g.stroke();
  }
  /* ⛔ CENTRAGE AU PIXEL DES GRANDES LETTRES. Les métriques actualBoundingBox
     mentent selon la police (Marcellus, scriptes) et les lettres partaient de
     travers deux fois (Adrien, 03/08/2026). Ici la lettre est dessinée hors
     écran, son encre est SCANNÉE, et le centre de l'encre est posé sur le centre
     de la case. Vrai pour toute police, par construction. */
  var cacheLettres = {};
  function dessineLettreCentree(g, lettre, cx, cy, taille, couleur) {
    var fam = etat.police && POLICES[etat.police] ? POLICES[etat.police] : SERIF;
    var cle = lettre + "|" + fam + "|" + taille;
    var entree = cacheLettres[cle];
    if (!entree) {
      var boite = taille * 2;
      var tampon = document.createElement("canvas");
      tampon.width = boite; tampon.height = boite;
      var tg = tampon.getContext("2d");
      tg.font = "500 " + taille + "px " + fam;
      tg.textAlign = "center"; tg.textBaseline = "middle";
      tg.fillStyle = "#000";
      tg.fillText(lettre, boite / 2, boite / 2);
      var x0 = boite, x1 = 0, y0 = boite, y1 = 0, trouve = false;
      try {
        var px = tg.getImageData(0, 0, boite, boite).data;
        for (var yy = 0; yy < boite; yy++) for (var xx = 0; xx < boite; xx++) {
          if (px[(yy * boite + xx) * 4 + 3] > 16) {
            trouve = true;
            if (xx < x0) x0 = xx; if (xx > x1) x1 = xx;
            if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
          }
        }
      } catch (e) {}
      entree = trouve
        ? { dx: boite / 2 - (x0 + x1 + 1) / 2, dy: boite / 2 - (y0 + y1 + 1) / 2 }
        : { dx: 0, dy: 0 };
      cacheLettres[cle] = entree;
    }
    var avantAlign = g.textAlign, avantBase = g.textBaseline, avantFont = g.font, avantFill = g.fillStyle;
    g.font = "500 " + taille + "px " + fam;
    g.textAlign = "center"; g.textBaseline = "middle";
    g.fillStyle = couleur;
    g.fillText(lettre, cx + entree.dx, cy + entree.dy);
    g.textAlign = avantAlign; g.textBaseline = avantBase; g.font = avantFont; g.fillStyle = avantFill;
  }
  /* Un MOT centré sur son encre, dans une famille imposée.
     ⛔ MÊME PIÈGE QUE POUR LES GRANDES LETTRES : `actualBoundingBoxAscent` ment selon la
     police, et un script a des jambages qui débordent largement de la boîte annoncée. Deux
     correctifs ont déjà échoué en s'y fiant. On mesure donc l'encre réelle dans un tampon hors
     écran, exactement comme `dessineLettreCentree`, et on ne s'en sert que comme DÉCALAGE : le
     tracé final se fait sur `g`, à la bonne échelle, donc rien à corriger du DPR. */
  var cacheMots = {};
  function motCentre(g, mot, cx, cy, taille, couleur, famille) {
    var cle = mot + "|" + famille + "|" + taille;
    var e = cacheMots[cle];
    if (!e) {
      var bw = Math.ceil(taille * (mot.length + 2)), bh = Math.ceil(taille * 2.4);
      var t = document.createElement("canvas");
      t.width = bw; t.height = bh;
      var tg = t.getContext("2d");
      tg.font = "400 " + taille + "px " + famille;
      tg.textAlign = "center"; tg.textBaseline = "middle";
      tg.fillStyle = "#000";
      tg.fillText(mot, bw / 2, bh / 2);
      var x0 = bw, x1 = 0, y0 = bh, y1 = 0, trouve = false;
      try {
        var px = tg.getImageData(0, 0, bw, bh).data;
        for (var yy = 0; yy < bh; yy++) for (var xx = 0; xx < bw; xx++) {
          if (px[(yy * bw + xx) * 4 + 3] > 16) {
            trouve = true;
            if (xx < x0) x0 = xx; if (xx > x1) x1 = xx;
            if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
          }
        }
      } catch (err) {}
      e = trouve ? { dx: bw / 2 - (x0 + x1 + 1) / 2, dy: bh / 2 - (y0 + y1 + 1) / 2 } : { dx: 0, dy: 0 };
      cacheMots[cle] = e;
    }
    var aA = g.textAlign, aB = g.textBaseline, aF = g.font, aC = g.fillStyle;
    g.font = "400 " + taille + "px " + famille;
    g.textAlign = "center"; g.textBaseline = "middle";
    g.fillStyle = couleur;
    g.fillText(mot, cx + e.dx, cy + e.dy);
    g.textAlign = aA; g.textBaseline = aB; g.font = aF; g.fillStyle = aC;
  }
  /* Le cache tombe quand la police change (le décalage d'encre change avec elle). */

  /* ⛔ UNE CURSIVE NE SE MET PAS EN CAPITALES (Adrien, 15/08/2026 : « police illisible »,
     capture du mot FAMILLE en Great Vibes). C'est LA cause, et elle est plus grosse que
     l'espacement corrige plus bas : les majuscules d'une anglaise sont des PARAFES, dessines
     pour apparaitre UNE fois en tete de mot. Sept a la suite, leurs boucles se traversent et le
     mot devient un noeud. En bas de casse, la meme police est parfaitement lisible : c'est pour
     ca qu'elle a ete choisie, et il n'y a aucune raison de la retirer.
     ⚠️ LE TEXTE DU CLIENT N'EST PAS TOUCHE, seule la casse du DESSIN change. S'il tape en
     capitales, elles restent : on ne force pas la minuscule, on cesse juste de forcer la
     majuscule. */
  /* ⛔⛔ ET IL FAUT PASSER PAR ICI, TOUJOURS (Adrien, 20/08/2026 : « il y a toujours le meme
     probleme, toujours avec la meme police, corrige partout »). Le correctif du 15/08 avait ete
     pose sur SEPT des quinze traces ; les huit autres appelaient `.toUpperCase()` en direct, dont
     la legende sous la grille — celle de sa capture, « MOMENTS DE BONHEUR » en Great Vibes, les
     parafes empiles. Une regle appliquee a la main a chaque appel est une regle qu'on oublie a
     l'appel suivant, et le defaut revient par le trace qu'on n'avait pas vu.
     ⚠️ UN BANC INTERDIT DESORMAIS `.toUpperCase()` DANS UN APPEL A `texteEspace` : c'est la seule
     forme de garde qui survive au prochain gabarit ajoute. */
  function capitales(txt, g) {
    if (!/Great Vibes|Apple Chancery|cursive/i.test(String((g && g.font) || ""))) {
      return String(txt).toUpperCase();
    }
    /* ⚠️ ET ON REDESCEND LA CASSE, on ne se contente pas de ne plus la forcer. Premiere version
       de cette fonction : rendre le texte tel quel pour les cursives. Sans effet, et je l'ai vu
       trop tard : le mot de la capture etait le texte PAR DEFAUT, stocke en capitales dans les
       locales (« FAMILLE »), et un client qui tape en capitales fait pareil. Ne plus forcer ne
       suffit donc pas, il faut DEFAIRE, sinon l'anglaise reste illisible dans les deux cas les
       plus frequents.
       ⛔ SEULE L'INITIALE DE LA PHRASE SE LEVE, PAS CHAQUE MOT. Premiere ecriture : une capitale
       par mot. Le banc l'a montre tout de suite, « TOI ET MOI » devenait « Toi Et Moi » et
       « l'ete a grasse » devenait « L'Été À Fayence ». C'est de la capitalisation anglaise, elle
       est fautive en francais et elle se voit sur une affiche encadree. Une majuscule ouvre la
       phrase, le reste suit en bas de casse : c'est ce pour quoi une anglaise est dessinee. */
    return enBasDeCasse(txt);
  }
  /* ⛔ UNE MAJUSCULE OUVRE LA PHRASE, LE RESTE SUIT EN BAS DE CASSE. Premiere ecriture : une
     capitale par mot. Le banc l'a montre tout de suite, « TOI ET MOI » devenait « Toi Et Moi »
     et « l'ete a grasse » devenait « L'Été À Fayence ». C'est de la capitalisation anglaise, elle
     est fautive en francais et elle se voit sur une affiche encadree. */
  function enBasDeCasse(txt) {
    var bas = String(txt).toLowerCase();
    return bas.replace(/\p{L}/u, function (l) { return l.toUpperCase(); });
  }

  /* Interlettrage à la main : canvas letterSpacing n'existe pas partout. */
  function texteEspace(g, txt, cx, y, esp, align) {
    /* ⛔ UNE CURSIVE LIEE NE S'ESPACE PAS, ON LA DESSINE D'UN SEUL TRAIT (Adrien, 15/08/2026 :
       « police illisible », capture du mot FAMILLE en Great Vibes). Cette fonction dessine
       LETTRE PAR LETTRE, seule facon d'espacer sur un canvas ou `letterSpacing` n'existe pas.
       Sur une capitale batonnee, c'est sans consequence. Sur une anglaise, chaque glyphe porte
       une attaque et une sortie faites pour se JOINDRE a la voisine : les separer laisse des
       crochets dans le vide, et les majuscules a longue queue viennent chevaucher la lettre
       suivante. Le mot ne se lit plus, alors qu'aucun reglage n'est en faute : c'est le
       PROCEDE de dessin qui ne convient pas a cette famille.
       ⚠️ ON NE RETIRE PAS LA POLICE DU CHOIX : elle est belle et elle est demandee. On lui rend
       le seul trace qui la respecte, `fillText` en une fois, et l'espacement demande est ignore
       pour elle seule. Le mot reste centre sur la meme reference, donc rien ne bouge ailleurs. */
    if (/Great Vibes|Apple Chancery|cursive/i.test(String(g.font || ""))) {
      var avantA = g.textAlign;
      g.textAlign = align === "right" ? "right" : align === "left" ? "left" : "center";
      /* ⛔⛔ ET LA CASSE SE REDESCEND ICI, DANS LE SEUL PASSAGE OBLIGE (Adrien, 20/08/2026 :
         « toujours le meme probleme, toujours avec la meme police, corrige partout »).
         `capitales()` faisait deja ce travail, mais il fallait PENSER a l'appeler : le correctif
         du 15/08 avait ete pose sur sept des quinze traces, et les huit autres passaient des
         capitales telles quelles. La legende sous la grille en faisait partie, et c'est elle
         qu'Adrien a photographiee. Une regle qu'on applique a la main a chaque appel est une
         regle qu'on oublie a l'appel suivant, et le defaut revient par le trace qu'on n'avait
         pas vu.
         ⚠️ IDEMPOTENT : les appels qui passent deja par `capitales()` ne changent pas de
         resultat, cette fonction rendant le meme texte sur un texte deja en bas de casse. */
      g.fillText(enBasDeCasse(String(txt)), cx, y);
      g.textAlign = avantA;
      return;
    }
    var s = String(txt).split(""), total = 0, i, lw;
    for (i = 0; i < s.length; i++) total += g.measureText(s[i]).width;
    total += esp * Math.max(0, s.length - 1);
    /* `cx` est le centre par defaut ; en alignement droit c'est le bord droit. Sans ce cas,
       les coordonnees du mot manuscrit debordaient de la moitie de leur longueur. */
    var x = align === "right" ? cx - total : align === "left" ? cx : cx - total / 2;
    var avant = g.textAlign;
    g.textAlign = "center";
    for (i = 0; i < s.length; i++) {
      lw = g.measureText(s[i]).width;
      g.fillText(s[i], x + lw / 2, y);
      x += lw + esp;
    }
    g.textAlign = avant;
  }
  function lignesCoupees(g, txt, maxW) {
    var mots = String(txt).split(/\s+/), sortie = [], courante = "";
    for (var i = 0; i < mots.length; i++) {
      var essai = courante ? courante + " " + mots[i] : mots[i];
      if (g.measureText(essai).width > maxW && courante) { sortie.push(courante); courante = mots[i]; }
      else courante = essai;
    }
    if (courante) sortie.push(courante);
    return sortie;
  }

  /* Chiffres en mosaïque : masque du glyphe + grandes cases, découpe destination-in.
     ⛔ DEUX INVARIANTS, appris le 03/08/2026 :
     1. La liste des cases visibles se décide UNE fois, à l'échelle de référence.
        Décidée à chaque échelle, une case de bord apparaissait à l'impression et
        pas à l'aperçu et tout le remplissage se décalait d'un cran.
     2. Le canvas du masque a EXACTEMENT la taille du glyphe (boîte d'encombrement),
        à la référence COMME au dessin. Avec un canvas à la taille de la boîte de
        composition, le glyphe n'en remplissait que le haut à la référence et le
        tout au dessin : les cases tombaient hors du chiffre et il restait des
        trous en plein milieu. */
  var CORPS_REF = 400;
  var cacheRef = null;
  /* ⛔ Le découpage d'un glyphe en cases sert les chiffres ET le mot en photos
     (Adrien, 03/08/2026) : même masque bbox-exact à l'échelle de référence,
     même fusion des bandes trop fines, même calage des frontières sur les creux.
     Un seul code, donc une seule vérité entre l'aperçu et l'impression. */
  function glyphesRef(texte, police, COLS, RANGS, graisse) {
    graisse = graisse || "700";
    var chiffres = [], total = 0;
    for (var i = 0; i < texte.length; i++) {
      var ch = texte[i];
      var mesure = document.createElement("canvas").getContext("2d");
      mesure.font = graisse + " " + CORPS_REF + "px " + police;
      var m = mesure.measureText(ch);
      var gauche = m.actualBoundingBoxLeft || 0;
      var haut = m.actualBoundingBoxAscent || CORPS_REF * 0.72;
      var gw = Math.max(1, Math.ceil(gauche + (m.actualBoundingBoxRight || m.width)));
      var gh = Math.max(1, Math.ceil(haut + (m.actualBoundingBoxDescent || 0)));
      var masque = document.createElement("canvas");
      masque.width = gw; masque.height = gh;
      var mg = masque.getContext("2d");
      mg.font = graisse + " " + CORPS_REF + "px " + police;
      mg.fillText(ch, gauche, haut);
      var alpha = null;
      try { alpha = mg.getImageData(0, 0, gw, gh).data; } catch (e) {}
      function couvre(px, py) {
        if (!alpha) return true;
        var ix = Math.max(0, Math.min(gw - 1, Math.round(px)));
        var iy = Math.max(0, Math.min(gh - 1, Math.round(py)));
        return alpha[(iy * gw + ix) * 4 + 3] > 16;
      }
      /* Peu de photos, en grand : 2 colonnes x 3 rangs par chiffre, comme les
         modèles myposter (le 0 du modèle 30 montre 6 photos).
         ⛔ PAS DE TRANCHES : une case qui n'attrape qu'un coin du glyphe (moins de
         22 % de couverture) ne reçoit PAS sa propre photo, elle FUSIONNE avec sa
         voisine de colonne la mieux couverte, dont la photo s'étend à travers la
         zone fine. La supprimer trouerait la silhouette ; la garder montrait une
         tranche de photo sans intérêt (captures 32 et 29 d'Adrien, 03/08/2026). */
      var SEUIL = 0.22;
      var cw = gw / COLS, chh = gh / RANGS;
      var bandes = [];
      for (var cx = 0; cx < COLS; cx++) {
        var segs = [];
        for (var ry = 0; ry < RANGS; ry++) {
          var hits = 0;
          for (var sy = 0; sy < 5; sy++) for (var sx = 0; sx < 5; sx++) {
            if (couvre(cx * cw + cw * (sx + 0.5) / 5, ry * chh + chh * (sy + 0.5) / 5)) hits++;
          }
          segs.push({ y0: ry, y1: ry + 1, hits: hits, echant: 25 });
        }
        /* ⛔ PAS DE « var i » ICI : la boucle des chiffres au-dessus utilise i dans la
           même portée de fonction, et un compteur partagé sautait le second chiffre
           (planche de contrôle du 03/08/2026 : « 30 » ne rendait que le 3). */
        var encore = true;
        while (encore && segs.length > 1) {
          encore = false;
          for (var si = 0; si < segs.length; si++) {
            var cov = segs[si].hits / segs[si].echant;
            if (cov >= 0.02 && cov < SEUIL) {
              var avant = si > 0 ? segs[si - 1] : null;
              var apres = si < segs.length - 1 ? segs[si + 1] : null;
              var cible = avant && apres
                ? (avant.hits / avant.echant >= apres.hits / apres.echant ? avant : apres)
                : (avant || apres);
              cible.y0 = Math.min(cible.y0, segs[si].y0);
              cible.y1 = Math.max(cible.y1, segs[si].y1);
              cible.hits += segs[si].hits; cible.echant += segs[si].echant;
              segs.splice(si, 1);
              encore = true;
              break;
            }
          }
        }
        segs.forEach(function (s) {
          if (s.hits / s.echant < 0.02) return;   // region hors glyphe : invisible
          bandes.push({ cx: cx, y0: s.y0 / RANGS, y1: s.y1 / RANGS });
          total++;
        });
      }
      /* ⛔ LES FRONTIÈRES SE CALENT SUR LES CREUX DU GLYPHE. Une frontière posée en
         plein trait laissait une lèvre de la case voisine dépasser (captures 32 et 4
         d'Adrien, 03/08/2026 : la case du chat du 4 descendait sous la barre). On
         glisse chaque frontière vers la ligne la moins couverte à proximité. */
      function couvertureLigne(cx2, yPx) {
        var dedans = 0;
        for (var sx2 = 0; sx2 < 10; sx2++) {
          if (couvre(cx2 * cw + cw * (sx2 + 0.5) / 10, yPx)) dedans++;
        }
        return dedans / 10;
      }
      function couvertureRect(x0, y0, x1, y1) {
        var dedans = 0;
        for (var sy2 = 0; sy2 < 6; sy2++) for (var sx3 = 0; sx3 < 6; sx3++) {
          if (couvre(x0 + (x1 - x0) * (sx3 + 0.5) / 6, y0 + (y1 - y0) * (sy2 + 0.5) / 6)) dedans++;
        }
        return dedans / 36;
      }
      for (var bi = 0; bi < bandes.length; bi++) {
        var bb = bandes[bi];
        for (var bj = 0; bj < bandes.length; bj++) {
          var vv = bandes[bj];
          if (vv.cx !== bb.cx || Math.abs(vv.y0 - bb.y1) > 0.001) continue;
          var ybPx = bb.y1 * gh, meilleur = ybPx, mini = couvertureLigne(bb.cx, ybPx);
          for (var pas = -10; pas <= 10; pas++) {
            var essai = ybPx + pas * (gh / RANGS) * 0.06;
            if (essai <= bb.y0 * gh + gh * 0.08 || essai >= vv.y1 * gh - gh * 0.08) continue;
            var cvl = couvertureLigne(bb.cx, essai);
            if (cvl < mini) { mini = cvl; meilleur = essai; }
          }
          if (mini < 0.6 && Math.abs(meilleur - ybPx) > 1) {
            bb.y1 = meilleur / gh; vv.y0 = meilleur / gh;
          }
        }
      }
      /* Une colonne réduite à une bande trop peu couverte s'efface : l'autre colonne
         passe pleine largeur (le 1 devient une colonne unique, plus de tranche). */
      for (var col = 0; col < COLS; col++) {
        var maCol = bandes.filter(function (b2) { return b2.cx === col; });
        if (maCol.length !== 1) continue;
        var seule = maCol[0];
        var covSeule = couvertureRect(col * cw, seule.y0 * gh, (col + 1) * cw, seule.y1 * gh);
        if (covSeule >= SEUIL) continue;
        bandes = bandes.filter(function (b2) { return b2 !== seule; });
        total--;
        bandes.forEach(function (b2) { b2.pleine = true; });
      }
      chiffres.push({ ch: ch, ratio: gw / gh, ghRef: gh, cols: COLS, bandes: bandes });
    }
    return { chiffres: chiffres, total: total, police: police, graisse: graisse };
  }
  function nombreRef() {
    var n = nombreActuel();
    if (cacheRef && cacheRef.n === n) return cacheRef;
    cacheRef = glyphesRef(n, CHIFFRES, 2, 3, "700");
    cacheRef.n = n;
    return cacheRef;
  }
  /* Mot en photos : mêmes glyphes que les chiffres, mais le client choisit
     combien de photos entrent dans ses lettres (1 à 6 découpes par lettre). */
  var cachesLettres = {};
  var CONFIGS_LETTRES = [[1, 1], [1, 2], [2, 2], [2, 3]];
  function motLettres() {
    var mot = valeurTexte("mot").toUpperCase().replace(/\s+/g, "").slice(0, 7);
    return mot.length >= 2 ? mot : (T.l_mot || "PAPA");
  }
  function lettresBase(mot, cols, rangs) {
    var cle = mot + "|" + cols + "x" + rangs;
    if (!cachesLettres[cle]) cachesLettres[cle] = glyphesRef(mot, LETTRES, cols, rangs, "900");
    return cachesLettres[cle];
  }
  function lettresComptesDisponibles() {
    var mot = motLettres(), vus = {};
    CONFIGS_LETTRES.forEach(function (cfg) { vus[lettresBase(mot, cfg[0], cfg[1]).total] = true; });
    return Object.keys(vus).map(Number).sort(function (a, b) { return a - b; });
  }
  function lettresRef() {
    var mot = motLettres(), cible = compte("lettres"), meilleur = null;
    CONFIGS_LETTRES.forEach(function (cfg) {
      var c = lettresBase(mot, cfg[0], cfg[1]);
      if (!meilleur || Math.abs(c.total - cible) < Math.abs(meilleur.total - cible)) meilleur = c;
    });
    return meilleur;
  }
  function calculeNombre(W, H, ech) {
    return calculeGlyphes(nombreRef(), W, H, ech, 0.44 * H, 0.17 * H, 0.80, 0.045);
  }
  function calculeLettres(W, H, ech) {
    /* Le mot tient une bande centrale : titre au-dessus, formule et dédicace
       dessous, comme les modèles « LE MEILLEUR PAPA DU MONDE ». */
    return calculeGlyphes(lettresRef(), W, H, ech, 0.175 * H, 0.375 * H, 0.86, 0.022);
  }
  function calculeGlyphes(ref, W, H, ech, boxH, yHaut, largeurMax, gapFrac) {
    /* Géométrie à l'échelle demandée, cases reprises de la référence. */
    ech = ech || 1;
    var sortie = { chiffres: [], tuiles: [] };
    var totalW = 0;
    ref.chiffres.forEach(function (c) { totalW += boxH * c.ratio; });
    var gap = ref.chiffres.length > 1 ? gapFrac * W : 0;
    totalW += gap * (ref.chiffres.length - 1);
    var echelle = Math.min(1, largeurMax * W / totalW);
    var x = (W - totalW * echelle) / 2;
    ref.chiffres.forEach(function (c) {
      var chh = boxH * echelle, cw = chh * c.ratio;
      var masque = document.createElement("canvas");
      masque.width = Math.max(1, Math.ceil(cw * ech)); masque.height = Math.max(1, Math.ceil(chh * ech));
      var mg = masque.getContext("2d");
      mg.setTransform(ech, 0, 0, ech, 0, 0);
      var corps = Math.max(8, Math.floor(CORPS_REF * chh / c.ghRef));
      mg.font = (ref.graisse || "700") + " " + corps + "px " + (ref.police || CHIFFRES);
      var mm = mg.measureText(c.ch);
      mg.fillText(c.ch, (mm.actualBoundingBoxLeft || 0), (mm.actualBoundingBoxAscent || chh * 0.96));
      var sc = { ch: c.ch, masque: masque, x: x, y: yHaut + (boxH * echelle - chh) / 2 };
      sortie.chiffres.push(sc);
      var tw = cw / c.cols;
      c.bandes.forEach(function (b) {
        sortie.tuiles.push({ chiffre: sc,
          tx: b.pleine ? 0 : b.cx * tw, ty: b.y0 * chh,
          tw: b.pleine ? cw : tw, th: (b.y1 - b.y0) * chh });
      });
      x += cw + gap * echelle;
    });
    return sortie;
  }

  /* ⛔⛔ LA CROIX SE POSE APRES LE MASQUE, JAMAIS AVANT (Adrien, 23/08/2026 : « sur certaines
     mises en place dans la modale, les "+" pour ajouter une photo sont coupes : mot en photos ;
     coeur, nombre »). Ces gabarits-la dessinent leurs cases dans un tampon, puis n'en gardent
     que ce qui tombe DANS la forme (un chiffre, une lettre, un coeur) par `destination-in`. La
     croix, dessinee AVEC la case, se faisait donc trancher par la forme, et disparaissait
     entierement quand le centre de la case tombait hors du trait.

     Elle se pose maintenant APRES, dans le contexte de l'affiche, AU CENTRE DE CE QUI RESTE :
     on lit l'alpha du tampon deja masque, on prend le barycentre des pixels survivants, et la
     croix se dimensionne sur la plus petite dimension de cette tache. Une case reduite a une
     fine bande recoit une petite croix entiere, pas une grande croix coupee.

     ⚠️ `getImageData` ECHOUE SUR UN CANVAS TEINTE par une image d'un autre domaine, et sur la
     fiche les demos viennent du CDN Shopify. On sort alors sans rien dessiner, ce qui est le bon
     repli : ces cases-la portent deja une image, elles n'attendent pas de croix. Dans la fenetre,
     les demos ne sont pas dessinees et le tampon reste propre.

     ⚠️ ET ON NE LIT LES PIXELS QU'UNE FOIS PAR FORME, par pas grossier : c'est un dessin
     d'apercu, rejoue a chaque geste. */
  function croixApresMasque(g, tg, tampon, base, boites, ech) {
    if (!boites.length) return;
    var img;
    try { img = tg.getImageData(0, 0, tampon.width, tampon.height); } catch (e) { return; }
    var d = img.data, L = tampon.width;
    boites.forEach(function (b) {
      var x0 = Math.max(0, Math.round(b.x * ech)), y0 = Math.max(0, Math.round(b.y * ech));
      var x1 = Math.min(L, Math.round((b.x + b.w) * ech));
      var y1 = Math.min(tampon.height, Math.round((b.y + b.h) * ech));
      if (x1 <= x0 || y1 <= y0) return;
      var pas = Math.max(1, Math.round(Math.min(x1 - x0, y1 - y0) / 20));
      var sx = 0, sy = 0, n = 0, mnx = 1e9, mny = 1e9, mxx = -1e9, mxy = -1e9;
      for (var y = y0; y < y1; y += pas) {
        for (var x = x0; x < x1; x += pas) {
          if (d[(y * L + x) * 4 + 3] > 24) {
            sx += x; sy += y; n += 1;
            if (x < mnx) mnx = x; if (x > mxx) mxx = x;
            if (y < mny) mny = y; if (y > mxy) mxy = y;
          }
        }
      }
      if (!n) return;
      var cx = base.x + (sx / n) / ech, cy = base.y + (sy / n) / ech;
      var cote = Math.min(mxx - mnx, mxy - mny) / ech;
      if (!(cote > 4)) return;
      var l = cote * 0.22, ep = Math.max(1.2, cote * 0.035);
      g.save();
      g.strokeStyle = TRAIT_PLACEMENT; g.lineWidth = ep; g.lineCap = "round";
      g.beginPath();
      g.moveTo(cx - l, cy); g.lineTo(cx + l, cy);
      g.moveTo(cx, cy - l); g.lineTo(cx, cy + l);
      g.stroke();
      g.restore();
    });
  }

  function dessineGlyphes(g, calc, aff, apercu, ech) {
    calc.chiffres.forEach(function (c) {
      var tampon = document.createElement("canvas");
      tampon.width = c.masque.width; tampon.height = c.masque.height;
      var tg = tampon.getContext("2d");
      tg.setTransform(ech, 0, 0, ech, 0, 0);
      var vides = [];
      calc.tuiles.forEach(function (t, k) {
        if (t.chiffre !== c) return;
        var p = aff[k] >= 0 ? photos[aff[k]] : null;
        var marge = Math.min(t.tw, t.th) * 0.02;
        if (p) dessinePhoto(tg, p, t.tx + marge, t.ty + marge, t.tw - 2 * marge, t.th - 2 * marge, reglage(k));
        else if (!photos.length && apercu && dessineDemo(tg, k, t.tx + marge, t.ty + marge, t.tw - 2 * marge, t.th - 2 * marge)) { /* filigrane */ }
        else {
          /* Le fond de la case reste dans le tampon, il DOIT etre masque comme elle ; seule la
             croix attend la fin, voir `croixApresMasque`. */
          dessineVide(tg, t.tx + marge, t.ty + marge, t.tw - 2 * marge, t.th - 2 * marge, false);
          if (apercu) vides.push({ x: t.tx + marge, y: t.ty + marge, w: t.tw - 2 * marge, h: t.th - 2 * marge });
        }
      });
      tg.setTransform(1, 0, 0, 1, 0, 0);
      tg.globalCompositeOperation = "destination-in";
      tg.drawImage(c.masque, 0, 0);
      g.drawImage(tampon, c.x, c.y, tampon.width / ech, tampon.height / ech);
      croixApresMasque(g, tg, tampon, { x: c.x, y: c.y }, vides, ech);
    });
  }

  function dessine(g, W, H, apercu) {
    g.fillStyle = fondHex(); g.fillRect(0, 0, W, H);
    var gb = gabarit(), i;
    if (gb.id === "nombre") {
      var echN = echelleRendu(g);
      var calc = calculeNombre(W, H, echN);
      dessineGlyphes(g, calc, affectations(calc.tuiles.length), apercu, echN);
      var mot1 = valeurTexte("mot1"), mot2 = valeurTexte("mot2");
      g.textBaseline = "middle"; g.textAlign = "center";
      /* ⚠️ DEUX MOTS, DEUX POLICES POSSIBLES : la declaration de fonte etait UNE, posee avant
         de savoir lequel on ecrit. Elle est desormais reposee devant chaque mot, comme l'encre
         l'est deja juste au-dessus. */
      var corpsMot = Math.round(0.052 * H);
      if (mot1 && mot2) {
        g.fillStyle = encreChamp("mot1", "#1b1b1b"); g.font = fonte("400", corpsMot, SCRIPT, null, "mot1");
        g.save(); g.translate(0.36 * W, 0.665 * H); g.rotate(-0.05); g.fillText(mot1, 0, 0); g.restore();
        g.fillStyle = encreChamp("mot2", "#1b1b1b"); g.font = fonte("400", corpsMot, SCRIPT, null, "mot2");
        g.save(); g.translate(0.63 * W, 0.695 * H); g.rotate(-0.05); g.fillText(mot2, 0, 0); g.restore();
      } else if (mot1 || mot2) {
        var seul = mot1 ? "mot1" : "mot2";
        g.fillStyle = encreChamp(seul, "#1b1b1b"); g.font = fonte("400", corpsMot, SCRIPT, null, seul);
        g.save(); g.translate(0.5 * W, 0.675 * H); g.rotate(-0.05); g.fillText(mot1 || mot2, 0, 0); g.restore();
      }
      var noms = valeurTexte("noms");
      if (noms) {
        g.fillStyle = encreChamp("noms", "#8f959c");
        g.font = fonte("500", Math.round(0.016 * H), SANS, null, "noms");
        texteEspace(g, capitales(noms, g), 0.5 * W, 0.84 * H, 0.35 * 0.016 * H);
      }
      dessineSurvolTuiles(g, W, H, apercu);
      return;
    }
    if (gb.id === "lettres") {
      var echL = echelleRendu(g);
      var calcL = calculeLettres(W, H, echL);
      dessineGlyphes(g, calcL, affectations(calcL.tuiles.length), apercu, echL);
      g.textBaseline = "middle"; g.textAlign = "center";
      var surL = valeurTexte("sur");
      if (surL) {
        g.fillStyle = encreChamp("sur", "#2b3040");
        var tSur = Math.round(0.030 * H);
        g.font = fonte("500", tSur, SANS, null, "sur");
        texteEspace(g, capitales(surL, g), 0.5 * W, 0.325 * H, 0.30 * tSur);
      }
      var sousL = valeurTexte("sous");
      if (sousL) {
        g.fillStyle = encreChamp("sous", "#2b3040");
        var tSous = Math.round(0.030 * H);
        g.font = fonte("500", tSous, SANS, null, "sous");
        texteEspace(g, capitales(sousL, g), 0.5 * W, 0.605 * H, 0.30 * tSous);
      }
      var paraL = valeurTexte("para");
      if (paraL) {
        g.fillStyle = encreChamp("para", "#6b6f7a");
        g.font = fonte("400", Math.round(0.0145 * H), SANS, null, "para");
        var lgL = lignesCoupees(g, paraL, 0.62 * W);
        for (var iL = 0; iL < Math.min(lgL.length, 3); iL++) {
          g.fillText(lgL[iL], 0.5 * W, (0.665 + iL * 0.024) * H);
        }
      }
      var nomsL = valeurTexte("noms");
      if (nomsL) {
        g.fillStyle = encreChamp("noms", "#9aa0ab");
        var tNoms = Math.round(0.013 * H);
        g.font = fonte("500", tNoms, SANS, null, "noms");
        texteEspace(g, capitales(nomsL, g), 0.5 * W, 0.755 * H, 0.35 * tNoms);
      }
      dessineSurvolTuiles(g, W, H, apercu);
      return;
    }
    if (gb.id === "coeur") {
      var styleC = coeurStyle();
      g.textBaseline = "middle"; g.textAlign = "center";
      if (styleC === "bandes") {
        var echB = echelleRendu(g);
        var calcC = calculeCoeur(W, H, echB);
        var affC = affectations(calcC.tuiles.length);
        var tamponC = document.createElement("canvas");
        tamponC.width = calcC.masque.width; tamponC.height = calcC.masque.height;
        var tgC = tamponC.getContext("2d");
        tgC.setTransform(echB, 0, 0, echB, 0, 0);
        var videsC = [];
        calcC.tuiles.forEach(function (t, k) {
          var p = affC[k] >= 0 ? photos[affC[k]] : null;
          var marge = Math.min(t.tw, t.th) * 0.02;
          if (p) dessinePhoto(tgC, p, t.tx + marge, t.ty + marge, t.tw - 2 * marge, t.th - 2 * marge, reglage(k));
          else if (!photos.length && apercu && dessineDemo(tgC, k, t.tx + marge, t.ty + marge, t.tw - 2 * marge, t.th - 2 * marge)) { /* filigrane */ }
          else {
            dessineVide(tgC, t.tx + marge, t.ty + marge, t.tw - 2 * marge, t.th - 2 * marge, false, W);
            if (apercu) videsC.push({ x: t.tx + marge, y: t.ty + marge, w: t.tw - 2 * marge, h: t.th - 2 * marge });
          }
        });
        tgC.setTransform(1, 0, 0, 1, 0, 0);
        tgC.globalCompositeOperation = "destination-in";
        tgC.drawImage(calcC.masque, 0, 0);
        g.drawImage(tamponC, calcC.x, calcC.y, tamponC.width / echB, tamponC.height / echB);
        croixApresMasque(g, tgC, tamponC, { x: calcC.x, y: calcC.y }, videsC, echB);
        var legC = valeurTexte("legende");
        if (legC) {
          g.fillStyle = encreChamp("legende", "#1b1b1b");
          g.font = fonte("400", Math.round(0.055 * H), SCRIPT, null, "legende");
          g.save(); g.translate(0.5 * W, 0.83 * H); g.rotate(-0.05); g.fillText(legC, 0, 0); g.restore();
        }
        var nomsC = valeurTexte("noms");
        if (nomsC) {
          g.fillStyle = encreChamp("noms", "#8f959c");
          g.font = fonte("500", Math.round(0.016 * H), SANS, null, "noms");
          texteEspace(g, capitales(nomsC, g), 0.5 * W, 0.915 * H, 0.35 * 0.016 * H);
        }
      } else if (styleC === "posee" || styleC === "couronne") {
        var geoP = styleC === "couronne" ? geometrieCoeurCouronne(W, H) : geometrieCoeurPosee(W, H);
        var affP = affectations(geoP.tuiles.length);
        geoP.tuiles.forEach(function (t, k) {
          var cp = t.taille, xp = t.cx - cp / 2, yp = t.cy - cp / 2;
          var p = affP[k] >= 0 ? photos[affP[k]] : null;
          if (p) dessinePhoto(g, p, xp, yp, cp, cp, reglage(k));
          else if (!photos.length && apercu && dessineDemo(g, k, xp, yp, cp, cp)) { /* filigrane */ }
          else dessineVide(g, xp, yp, cp, cp, apercu, W);
        });
        var legP = valeurTexte("legende");
        if (legP) {
          g.fillStyle = encreChamp("legende", "#1b1b1b");
          g.font = fonte("400", Math.round(0.075 * H), SCRIPT, null, "legende");
          g.fillText(legP, 0.5 * W, 0.135 * H);
        }
        var citP = valeurTexte("citation");
        if (citP) {
          g.fillStyle = encreChamp("citation", "#3a3a38");
          g.font = fonte("500", Math.round(0.022 * H), SERIF, null, "citation");
          var lgP = lignesCoupees(g, citP, 0.56 * W);
          for (var ip = 0; ip < Math.min(lgP.length, 3); ip++) {
            g.fillText(lgP[ip], 0.5 * W, (0.855 + ip * 0.030) * H);
          }
        }
      } else {
        var echD = echelleRendu(g);
        var geoD = geometrieCoeurDiagonales(W, H);
        var affD = affectations(geoD.losanges.length);
        var videsD = [];
        var tamponD = document.createElement("canvas");
        tamponD.width = Math.ceil(geoD.cote * echD); tamponD.height = Math.ceil(geoD.cote * echD);
        var tgD = tamponD.getContext("2d");
        tgD.setTransform(echD, 0, 0, echD, 0, 0);
        geoD.losanges.forEach(function (t, k) {
          var lx = t.cx - geoD.x, ly = t.cy - geoD.y;
          var rr = t.rr * 0.93;                        // gouttière blanche entre losanges
          function losange(px, py) {
            tgD.moveTo(px, py - rr); tgD.lineTo(px + rr, py);
            tgD.lineTo(px, py + rr); tgD.lineTo(px - rr, py);
            tgD.closePath();
          }
          tgD.save();
          tgD.beginPath();
          losange(lx, ly);
          /* ⛔ LA PHOTO S'ETEND SUR LES ECHARDES QU'ELLE A ABSORBEES. Le losange
             voisin est ajoute au trace, et un quadrilatere comble la gouttiere
             entre les deux : sans lui, un liseré blanc traverserait la photo au
             milieu et on verrait le recollement. Ses quatre sommets sont les
             extremites des deux aretes qui se font face, donc il epouse la
             gouttiere exactement. */
          var boite = { x0: lx - rr, y0: ly - rr, x1: lx + rr, y1: ly + rr };
          (t.absorbes || []).forEach(function (d) {
            var ax = lx + d[0], ay = ly + d[1];
            var sx = d[0] > 0 ? 1 : -1, sy = d[1] > 0 ? 1 : -1;
            losange(ax, ay);
            tgD.moveTo(lx + sx * rr, ly);
            tgD.lineTo(ax, ay - sy * rr);
            tgD.lineTo(ax - sx * rr, ay);
            tgD.lineTo(lx, ly + sy * rr);
            tgD.closePath();
            boite.x0 = Math.min(boite.x0, ax - rr); boite.y0 = Math.min(boite.y0, ay - rr);
            boite.x1 = Math.max(boite.x1, ax + rr); boite.y1 = Math.max(boite.y1, ay + rr);
          });
          tgD.clip();
          var bw = boite.x1 - boite.x0, bh = boite.y1 - boite.y0;
          var p = affD[k] >= 0 ? photos[affD[k]] : null;
          if (p) dessinePhoto(tgD, p, boite.x0, boite.y0, bw, bh, reglage(k));
          else if (!photos.length && apercu && dessineDemo(tgD, k, boite.x0, boite.y0, bw, bh)) { /* filigrane */ }
          else {
            dessineVide(tgD, boite.x0, boite.y0, bw, bh, false, W);
            if (apercu) videsD.push({ x: boite.x0, y: boite.y0, w: bw, h: bh });
          }
          tgD.restore();
        });
        var masqueD = document.createElement("canvas");
        masqueD.width = tamponD.width; masqueD.height = tamponD.height;
        var mgD = masqueD.getContext("2d");
        mgD.setTransform(echD, 0, 0, echD, 0, 0);
        traceCoeur(mgD, geoD.cote, geoD.cote);
        mgD.fill();
        tgD.setTransform(1, 0, 0, 1, 0, 0);
        tgD.globalCompositeOperation = "destination-in";
        tgD.drawImage(masqueD, 0, 0);
        g.drawImage(tamponD, geoD.x, geoD.y, tamponD.width / echD, tamponD.height / echD);
        croixApresMasque(g, tgD, tamponD, { x: geoD.x, y: geoD.y }, videsD, echD);
        g.strokeStyle = encreChamp("titre", "#2a2a2a"); g.lineWidth = Math.max(1, 0.0011 * H);
        g.beginPath();
        g.moveTo(0.24 * W, 0.062 * H); g.lineTo(0.76 * W, 0.062 * H);
        g.moveTo(0.24 * W, 0.145 * H); g.lineTo(0.76 * W, 0.145 * H);
        g.stroke();
        g.fillStyle = encreChamp("titre", "#1d1d1b");
        var tD = Math.round(0.045 * H);
        g.font = fonte("500", tD, SERIF, null, "titre");
        texteEspace(g, capitales(valeurTexte("titre"), g), 0.5 * W, 0.104 * H, 0.08 * tD);
        var nomsD = valeurTexte("noms");
        if (nomsD) {
          g.fillStyle = encreChamp("noms", "#6b6b68");
          g.font = fonte("400", Math.round(0.014 * H), MACHINE, null, "noms");
          texteEspace(g, nomsD, 0.5 * W, 0.175 * H, 0.12 * 0.014 * H);
        }
        var sousD = valeurTexte("sous");
        if (sousD) {
          g.fillStyle = encreChamp("sous", "#141414");
          var tsD = Math.round(0.026 * H);
          g.font = fonte("500", tsD, SERIF, null, "sous");
          texteEspace(g, capitales(sousD, g), 0.5 * W, 0.845 * H, 0.24 * tsD);
        }
        var paraD = valeurTexte("para");
        if (paraD) {
          g.fillStyle = encreChamp("para", "#555555");
          g.font = fonte("400", Math.round(0.012 * H), SANS, null, "para");
          var lgD = lignesCoupees(g, paraD, 0.6 * W);
          for (var ld = 0; ld < Math.min(lgD.length, 3); ld++) g.fillText(lgD[ld], 0.5 * W, (0.885 + ld * 0.02) * H);
        }
      }
      dessineSurvolTuiles(g, W, H, apercu);
      return;
    }
    var geoDamier = gb.id === "damier-love" ? geometrieDamier(lettresDamier()) : null;
    var cases_ = geoDamier ? geoDamier.photos : casesCourantes();
    var aff2 = affectations(cases_.length);
    for (i = 0; i < cases_.length; i++) {
      var c2 = cases_[i], x = c2[0] * W, y = c2[1] * H, w = c2[2] * W, h = c2[3] * H;
      var p = aff2[i] >= 0 ? photos[aff2[i]] : null;
      if (p) dessinePhoto(g, p, x, y, w, h, reglage(i));
      else if (!photos.length && apercu && dessineDemo(g, i, x, y, w, h)) { /* filigrane */ }
      else dessineVide(g, x, y, w, h, apercu, W);
    }
    g.textBaseline = "middle"; g.textAlign = "center";
    if (gb.id === "decalee" && estManuscrit()) {
      /* ⛔ LE MOT SE TRACE ICI, PAS EN CSS PAR-DESSUS LE CANVAS. Une seule fonction dessine
         l'aperçu ET le fichier d'impression : un mot posé en CSS s'afficherait à l'écran et
         manquerait sur le tirage, sans que rien ne le signale. */
      var mot = valeurTexte("mot");
      if (mot) {
        /* La taille se déduit de la largeur mesurée : « Toi » et « Pour toujours » ne peuvent
           pas partager la même. On vise 84 % de la page, on plafonne à 0,15 H pour qu'un mot
           court ne dévore pas les photos. */
        var tm = Math.round(0.15 * H);
        /* ⛔ PAS `fonte(, null, null, null, "para")` ICI : elle substitue la police choisie par le client, et le mot
           manuscrit ne serait plus manuscrit. Ce style REPOSE sur le script. */
        g.font = "400 " + tm + "px " + SCRIPT;
        var lm = g.measureText(mot).width;
        if (lm > 0.84 * W) tm = Math.max(12, Math.floor(tm * (0.84 * W) / lm));
        g.save();
        g.translate(0.5 * W, 0.44 * H);
        g.rotate(-8 * Math.PI / 180);
        /* L'ombre porte le mot sur des photos claires comme sur des sombres. Sans elle, un
           blanc sur un ciel surexposé disparaît, et c'est justement là qu'on le pose. */
        g.shadowColor = "rgba(0,0,0,.34)";
        g.shadowBlur = Math.max(2, 0.012 * H);
        g.shadowOffsetY = Math.max(1, 0.003 * H);
        motCentre(g, mot, 0, 0, tm, encreChamp("mot", "#ffffff"), SCRIPT);
        g.restore();
      }
      /* ⛔ LE FILET NE S'AFFICHE QUE S'IL SÉPARE QUELQUE CHOSE. Les coordonnées partent vides,
         c'est un placeholder et non une valeur : tracé quand même, le filet fermait une bande
         vide et la composition se terminait sur un trait pour rien. Sans coordonnées, la
         légende se recentre dans le bandeau, et le trait disparaît avec ce qu'il séparait. */
      var co = valeurTexte("coord");
      var legM = valeurTexte("legende");
      if (legM) {
        g.fillStyle = encreChamp("legende", "#23211e");
        var tl = Math.round(0.021 * H);
        g.font = fonte("400", tl, SERIF, "italic", "legende");
        g.textAlign = "left";
        g.fillText(legM, 0.06 * W, (co ? 0.917 : 0.938) * H);
      }
      if (co) {
        g.strokeStyle = encreChamp("legende", "#23211e");
        g.globalAlpha = 0.45;
        g.lineWidth = Math.max(1, 0.0009 * H);
        g.beginPath(); g.moveTo(0.06 * W, 0.940 * H); g.lineTo(0.94 * W, 0.940 * H); g.stroke();
        g.globalAlpha = 1;
        g.fillStyle = encreChamp("coord", "#6d6a63");
        var tc = Math.round(0.0135 * H);
        g.font = fonte("400", tc, SANS, null, "coord");
        g.textAlign = "right";
        texteEspace(g, capitales(co, g), 0.94 * W, 0.966 * H, 0.16 * tc, "right");
      }
      g.textAlign = "center";
    } else if (gb.id === "decalee" && !estPleinBord()) {
      var leg = valeurTexte("legende");
      if (leg) {
        g.fillStyle = encreChamp("legende", "#23211e");
        var t6 = Math.round(0.024 * H);
        g.font = fonte("500", t6, SANS, null, "legende");
        texteEspace(g, capitales(leg, g), 0.5 * W, 0.917 * H, 0.30 * t6);
      }
    } else if (gb.id === "grille" && etat.texteStyle === "filets") {
      g.strokeStyle = encreChamp("titre", "#2a2a2a"); g.lineWidth = Math.max(1, 0.0011 * H);
      g.beginPath();
      g.moveTo(0.24 * W, 0.086 * H); g.lineTo(0.76 * W, 0.086 * H);
      g.moveTo(0.24 * W, 0.158 * H); g.lineTo(0.76 * W, 0.158 * H);
      g.stroke();
      g.fillStyle = encreChamp("titre", "#1d1d1b");
      var t30 = Math.round(0.048 * H);
      g.font = fonte("500", t30, SERIF, null, "titre");
      texteEspace(g, capitales(valeurTexte("titre"), g), 0.5 * W, 0.122 * H, 0.08 * t30);
      var s30 = valeurTexte("sous");
      if (s30) {
        g.fillStyle = encreChamp("sous", "#8a8a8a");
        var ts = Math.round(0.0125 * H);
        g.font = fonte("400", ts, SANS, null, "sous");
        texteEspace(g, s30, 0.5 * W, 0.187 * H, 0.14 * ts);
      }
    } else if (gb.id === "grille" && etat.texteStyle === "lettres") {
      g.fillStyle = encreChamp("titre", "#141414");
      var t9 = Math.round(0.034 * H);
      g.font = fonte("500", t9, SERIF, null, "titre");
      texteEspace(g, capitales(valeurTexte("titre"), g), 0.5 * W, 0.128 * H, 0.24 * t9);
      var s9 = valeurTexte("sous");
      if (s9) {
        g.fillStyle = encreChamp("sous", "#141414");
        var ts9 = Math.round(0.026 * H);
        g.font = fonte("500", ts9, SERIF, null, "sous");
        texteEspace(g, capitales(s9, g), 0.5 * W, 0.780 * H, 0.24 * ts9);
      }
      var para = valeurTexte("para");
      if (para) {
        g.fillStyle = encreChamp("para", "#555555");
        g.font = fonte("400", Math.round(0.0122 * H), MACHINE, null, "para");
        var lg = lignesCoupees(g, para, 0.64 * W);
        for (var l = 0; l < Math.min(lg.length, 3); l++) g.fillText(lg[l], 0.5 * W, (0.835 + l * 0.021) * H);
      }
    } else if (gb.id === "damier-love") {
      /* Les lettres seules, sans petits mots (Adrien, 03/08/2026). L'encre choisie
         remplace la palette ; en automatique la palette reste, même sur fond sombre. */
      geoDamier.lettres.forEach(function (cel) {
        var cx = (cel.x + cel.w / 2) * W, cy = (cel.y + cel.h / 2) * H;
        var coul = encreDuChamp("lettres") ? MATS[encreDuChamp("lettres")] : cel.couleur;
        dessineLettreCentree(g, cel.lettre, cx, cy, Math.round(cel.h * H * 0.72), coul);
      });
    }
    if (apercu && survol >= 0 && cases_[survol]) {
      var sc = cases_[survol];
      g.strokeStyle = "#ffffff"; g.lineWidth = Math.max(3, W * 0.008);
      g.strokeRect(sc[0] * W + 1.5, sc[1] * H + 1.5, sc[2] * W - 3, sc[3] * H - 3);
      g.strokeStyle = "#B8714C"; g.lineWidth = Math.max(2, W * 0.005);
      g.strokeRect(sc[0] * W + 1.5, sc[1] * H + 1.5, sc[2] * W - 3, sc[3] * H - 3);
    }
    /* ⛔ LE RETOUR VISUEL DU DEPLACEMENT PASSE PAR LA MEME GEOMETRIE QUE LE CLIC. `cases_` ne
       decrit que les gabarits en grille ; le nombre, le coeur et les lettres placent leurs
       tuiles par `tuilesEcran`, et c'est deja `caseAuPoint` qui fait cette distinction. Peindre
       la prise depuis `cases_` seul aurait donne un voile a cote de la tuile saisie sur ces
       trois gabarits, ou rien du tout : le client ne verrait pas ce qu'il tient. */
    if (apercu && deplacement) {
      var rp = rectCase(deplacement.i, W, H);
      if (rp) { g.fillStyle = "rgba(251,247,240,.66)"; g.fillRect(rp[0], rp[1], rp[2], rp[3]); }
      var rc = deplacement.cible !== deplacement.i ? rectCase(deplacement.cible, W, H) : null;
      if (rc) {
        g.strokeStyle = "#ffffff"; g.lineWidth = Math.max(3, W * 0.008);
        g.strokeRect(rc[0] + 1.5, rc[1] + 1.5, rc[2] - 3, rc[3] - 3);
        g.strokeStyle = "#B8714C"; g.lineWidth = Math.max(2, W * 0.005);
        g.strokeRect(rc[0] + 1.5, rc[1] + 1.5, rc[2] - 3, rc[3] - 3);
      }
    }
  }
  /* Le rectangle d'ecran d'une case, quel que soit le gabarit. Les losanges des diagonales
     rendent leur boite englobante : elle suffit a montrer laquelle est visee. */
  function rectCase(i, W, H) {
    if (!(i >= 0)) return null;
    var gb = gabarit();
    if (gb.id === "nombre" || gb.id === "coeur" || gb.id === "lettres") {
      var q = (tuilesEcran(W, H) || [])[i];
      if (!q) return null;
      return q.diamant ? [q.cx - q.rr, q.cy - q.rr, q.rr * 2, q.rr * 2] : [q.x, q.y, q.w, q.h];
    }
    var c = casesCourantes()[i];
    return c ? [c[0] * W, c[1] * H, c[2] * W, c[3] * H] : null;
  }

  /* ---- Aperçu dans le cadre ---- */
  var interne = document.querySelector(".pdp-frame__inner");
  if (!interne) return;
  var scene = document.createElement("canvas");
  scene.id = "pelemele-scene";
  interne.appendChild(scene);
  var ctx = scene.getContext("2d");

  var demande = false;
  function planifie() {
    if (demande) return;
    demande = true;
    /* ⛔ UNE LARGEUR NULLE N'EST PAS UNE REPONSE, C'EST UNE ATTENTE (Adrien, 15/08/2026 :
       « l'import de photo ne fonctionne pas », teste sur la grille decalee).

       CE QUE LA MESURE A MONTRE, dans son Chrome : le clic OUVRE bien le selecteur de fichiers,
       mais `#pelemele-scene` porte encore `width=300 height=150`, les valeurs PAR DEFAUT d'un
       canvas jamais dimensionne, alors que sa boite CSS fait 209 x 302. La scene n'a donc jamais
       ete initialisee : la photo choisie se dessinait dans un tampon qui n'a rien a voir avec ce
       qu'on voit, c'est-a-dire nulle part.

       ⛔ LA CAUSE EST CE `return` SEC. Si la scene mesure 0 au premier passage, parce qu'elle
       est encore masquee, parce qu'une largeur s'anime, parce que la galerie vient de passer en
       `position:sticky`, on sortait SANS JAMAIS REDEMANDER. Rien ne rappelait `planifie` : le
       ResizeObserver ne tire que si la taille CHANGE, et une taille qui reste nulle ne change
       pas. Un seul zero au mauvais moment condamnait la scene pour toute la visite.
       ⚠️ ET C'EST MOI QUI AI CREE CE MAUVAIS MOMENT : mes regles des series 303 a 306 ont mis
       cette galerie en `sticky` et lui ont donne une largeur animee. Le defaut dormait depuis
       toujours dans ce `return` ; je l'ai reveille.

       ⛔ PAS DE requestAnimationFrame POUR LE VERROU, meme raison qu'hier dans global.js : rAF
       NE TIRE PAS dans un onglet cache, et `demande` resterait a `true` pour toujours. Un
       client qui ouvre la fiche dans un onglet d'arriere-plan, ce que fait tout clic du milieu
       comme toute ouverture depuis une publicite, n'aurait plus jamais de scene. */
    var essais = 0;
    (function attend() {
      var r = scene.getBoundingClientRect();
      if (!r.width) {
        if (essais++ < 60) { setTimeout(attend, 50); return; }
        demande = false;
        return;
      }
      poser(r);
    })();
    function poser(r) {
      demande = false;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      if (scene.width !== Math.round(r.width * dpr) || scene.height !== Math.round(r.height * dpr)) {
        scene.width = Math.round(r.width * dpr); scene.height = Math.round(r.height * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      dessine(ctx, r.width, r.height, true);
      planifieMockup();
      /* Changer de mise en page ou de nombre change la taille des cases, donc la
         qualite d'impression : la pastille suit le dessin. */
      if (window.__pdpQcSync) window.__pdpQcSync();
    }
  }
  if (window.ResizeObserver) new ResizeObserver(planifie).observe(interne);
  window.addEventListener("resize", planifie);

  function deselectionne() { selection = -1; planifie(); }

  /* La pièce en situation reprend le collage (sinon elle montre l'affiche d'exemple). */
  var minuterieMockup = null;
  function planifieMockup() {
    if (minuterieMockup) clearTimeout(minuterieMockup);
    minuterieMockup = setTimeout(function () {
      minuterieMockup = null;
      if (!photos.length) return;
      try {
        var c = document.createElement("canvas");
        c.width = 400; c.height = Math.round(400 / RATIO);
        dessine(c.getContext("2d"), c.width, c.height, false);
        var d = c.toDataURL("image/jpeg", 0.8);
        Array.prototype.forEach.call(document.querySelectorAll('span[id="pdp-mockup-art"]'), function (el) {
          el.style.backgroundImage = "url('" + d + "')";
          el.removeAttribute("data-example");
        });
      } catch (e) {}
    }, 500);
  }

  /* ---- Import des photos ---- */
  var fichierInput = $("#pdp-file");
  var cibleRemplacement = null;
  function chargePhoto(f) {
    var url = URL.createObjectURL(f);
    function parImage() {
      return new Promise(function (res, rej) {
        var img = new Image();
        img.onload = function () { res({ bmp: img, w: img.naturalWidth, h: img.naturalHeight, url: url, fichier: f }); };
        img.onerror = rej;
        img.src = url;
      });
    }
    /* Un fichier refuse garde son URL d'objet vivante jusqu'au rechargement de la page. Ce
       n'etait pas visible tant qu'un refus emportait tout l'import ; maintenant qu'on continue
       avec les autres photos, un client qui reessaie trois fois en accumulerait autant. */
    function rendMemoire(e) { try { URL.revokeObjectURL(url); } catch (x) {} throw e; }
    if (!window.createImageBitmap) return parImage().catch(rendMemoire);
    return createImageBitmap(f, { imageOrientation: "from-image" })
      .catch(function () { return createImageBitmap(f); })
      .then(function (bmp) { return { bmp: bmp, w: bmp.width, h: bmp.height, url: url, fichier: f }; })
      .catch(parImage)
      .catch(rendMemoire);
  }
  /* ⛔ AUCUNE PHOTO NE DISPARAIT SANS UN MOT (client neerlandais, 15/08/2026 : « Ik druk op
     klaar en weg is de foto »). Ce « Klaar » est le bouton du SELECTEUR DE PHOTOS DU TELEPHONE,
     pas un bouton du site. La photo partait dans deux trappes, toutes deux muettes :

     1. LE FILTRE SUR LE TYPE MIME. Le champ est `multiple` ici. L'ancien code gardait les
        `image/jpeg` et `image/png`, puis n'affichait un message QUE si la liste retenue etait
        VIDE. Quatre photos dont une en HEIC, ou une dont le telephone annonce `image/jpg`
        (non standard, mais des Android l'envoient), et la quatrieme etait jetee en silence.
     2. `Promise.all` EST TOUT OU RIEN. Une seule photo illisible faisait echouer la promesse
        globale, et les trois autres, parfaitement valides, etaient perdues avec elle.

     Le type MIME ne juge plus rien : c'est le DECODAGE qui tranche, fichier par fichier, et ce
     qui n'a pas pu etre lu est NOMME. Un client qui voit « IMG_4021.HEIC » sait quoi refaire ;
     un client qui ne voit rien croit que le site a mange sa photo.

     ⚠️ NE PAS ELARGIR `accept` DANS main-product.liquid POUR AUTANT. La liste etroite
     (`image/jpeg,image/png`) est precisement ce qui fait convertir le HEIC en JPEG par iOS au
     moment du choix. L'elargir laisserait entrer des HEIC bruts qu'aucun Android ne decode. */
  function importe(fichiers) {
    var tous = Array.prototype.slice.call(fichiers);
    if (!tous.length) return;
    var reglees = tous.map(function (f) {
      return chargePhoto(f).then(
        function (p) { return { ok: true, photo: p }; },
        function () { return { ok: false, nom: f.name || "" }; }
      );
    });
    Promise.all(reglees).then(function (issues) {
      var nouvelles = [], refusees = [];
      issues.forEach(function (r) { if (r.ok) nouvelles.push(r.photo); else refusees.push(r.nom); });
      if (refusees.length && window.murToast) {
        var noms = refusees.filter(Boolean).join(", ");
        window.murToast(noms
          ? (TI.perso_files_refused || "Ces photos n'ont pas pu être lues, elles n'ont pas été ajoutées : ") + noms
          : (TI.perso_bad_type_photo || "Format non accepté : importez un JPG ou un PNG"));
      }
      if (!nouvelles.length) return;
      var premiere = photos.length === 0;
      /* ⛔ Remplacer UNE case ne bouge QUE cette case : l'affectation visible est
         figee AVANT l'ajout (le compte de photos change les affectations
         automatiques), puis la photo remplacee quitte la planche si plus aucune
         case ne la montre (Adrien, 03/08/2026 : « ça modifie plusieurs cases »). */
      var cible = cibleRemplacement;
      var avantAff = cible != null ? affectations() : null;
      nouvelles.forEach(function (p) { photos.push(p); });
      if (cible != null && nouvelles.length) {
        avantAff.forEach(function (pi, c) { if (pi >= 0 && c !== cible) manuel[c] = pi; });
        var ancien = avantAff[cible];
        manuel[cible] = photos.indexOf(nouvelles[0]);
        delete cadrage[cible];
        cibleRemplacement = null;
        if (ancien >= 0) {
          var encore = Object.keys(manuel).some(function (k) { return manuel[k] === ancien; });
          if (!encore) retirePhoto(ancien);
        }
      }
      cibleRemplacement = null;
      /* Le pele-mele passe par le meme funnel : l'URL part des que la premiere
         photo est deposee sur le serveur, pour que le Studio l'ouvre. */
      if (premiere && window.__persoFunnel) {
        var premiereDistante = function () {
          for (var d = 0; d < photos.length; d++) if (photos[d].distant) return photos[d].distant;
          return "";
        };
        /* L'evenement doit porter l'image : a 2,5 s les gros depots n'avaient pas fini
           et l'import partait sans lien (« — » dans le Studio, 04/08/2026). On attend
           l'URL jusqu'a 12,5 s avant de se resoudre a compter l'import sans elle. */
        (function attendDepot(restants) {
          if (premiereDistante() || restants <= 0) {
            window.__persoFunnel("import", premiereDistante());
            return;
          }
          setTimeout(function () { attendDepot(restants - 1); }, 2500);
        })(5);
      }
      nouvelles.forEach(envoiFond);
      majPile(); planifie(); majCtaColle(); majCtaRendu(); persiste(); majQualite();
      /* Meme raison que sur l'affiche personnalisee : la premiere photo posee, on
         remonte sur « Mise en page » pour que les reglages soient sous les yeux. */
      if (premiere && window.__pdpRemonteOptions) {
        setTimeout(function () { window.__pdpRemonteOptions(); }, 120);
      }
    }).catch(function () {
      if (window.murToast) window.murToast(TI.perso_upload_failed || "Lecture de la photo impossible, réessayez");
    });
  }
  /* ⛔ LA QUALITE D'UN PELE-MELE SE JUGE PAR CASE, PAS SUR L'AFFICHE. Une photo de
     1000 px dans une case qui fait un huitieme de l'affiche est large ; la meme sur
     un plein bord ne l'est pas. On rend donc le PIRE rapport « pixels de la photo
     par pixel de l'affiche » du collage, et product.js le convertit en DPI selon le
     format choisi, avec les memes seuils que la photo unique. */
  window.__pelemelePireRatio = function () {
    try {
      if (!photos.length) return 0;
      var W = 2200, H = Math.round(W / 0.6923);
      var cases = tuilesEcran(W, H);
      if (!cases || !cases.length) return 0;
      var aff = affectations(cases.length), pire = 0;
      for (var i = 0; i < cases.length; i++) {
        var q = cases[i];
        var cw = q.diamant ? q.rr * 2 : q.w, ch = q.diamant ? q.rr * 2 : q.h;
        var p = aff[i] >= 0 ? photos[aff[i]] : null;
        if (!p || !cw || !ch) continue;
        var r = Math.min(p.w / cw, p.h / ch);
        if (!pire || r < pire) pire = r;
      }
      return pire;
    } catch (e) { return 0; }
  };
  function majQualite() { if (window.__pdpQcSync) window.__pdpQcSync(); }

  fichierInput && fichierInput.addEventListener("change", function (e) {
    importe(e.target.files || []);
    e.target.value = "";
  });
  /* Chaque photo part en fond vers l'app : son URL stable permet de restaurer le
     collage au rechargement de la page (les modifications ne s'écrasent plus,
     Adrien, 03/08/2026). Un échec d'envoi laisse la photo locale fonctionner. */
  function envoiFond(p) {
    var endpoint = window.__persoUpload;
    if (!endpoint || !p.fichier || p.distant) return;
    fetch(endpoint, { method: "POST", headers: { "Content-Type": p.fichier.type }, body: p.fichier })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.url) {
          p.distant = j.preview || j.url;
          /* L'URL PLEINE, pas l'apercu : c'est elle qui part dans les proprietes de la
             commande. La 1114 n'avait AUCUNE source rattachee (11/08/2026) : chaque photo
             etait bien deposee ici, mais rien ne la referencait cote commande, et un SAV
             ne pouvait pas recomposer le collage. */
          p.distantSource = j.url;
          persiste();
        }
      })
      .catch(function () {});
  }
  /* Restauration du collage d'une session précédente : les photos reviennent
     depuis leurs URL stables, puis cadrages et affectations reprennent. */
  function restaurePhotos() {
    if (!sessionARestaurer) return;
    var lu2 = sessionARestaurer;
    sessionARestaurer = null;
    var chargees = [];
    var restantes = lu2.ph.length;
    lu2.ph.forEach(function (u, i) {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        chargees[i] = { bmp: img, w: img.naturalWidth, h: img.naturalHeight, url: u, distant: u };
        if (--restantes === 0) finRestaure();
      };
      img.onerror = function () { if (--restantes === 0) finRestaure(); };
      img.src = u;
    });
    function finRestaure() {
      var pleines = chargees.filter(Boolean);
      if (!pleines.length) return;
      photos = pleines;
      /* Les index ne valent que si TOUTES les photos sont revenues. */
      if (pleines.length === lu2.ph.length) {
        if (lu2.ma && typeof lu2.ma === "object") manuel = lu2.ma;
        if (lu2.ca && typeof lu2.ca === "object") cadrage = lu2.ca;
      }
      majPile(); planifie(); majCtaColle();
    }
  }
  restaurePhotos();

  var racine = document.querySelector(".pdp--pelemele");
  var pile = $("#pelemele-photos");
  var boutonAjout = $("#pelemele-add");
  var compteEl = $("#pelemele-compte");
  boutonAjout && boutonAjout.addEventListener("click", function () {
    cibleRemplacement = null;
    fichierInput && fichierInput.click();
  });
  /* ⛔ L'ETAT DE LA PLANCHE SE POSE MEME SANS LA BANDE DE VIGNETTES (Adrien, serie 320 : « vire
     ça dans le pele mele aussi pour tous les layout ça prend de la place pour rien »).

     Le bloc VOS PHOTOS est retire du gabarit. Cette fonction commencait par `if (!pile) return`,
     et cette ligne gardait bien plus que les vignettes : la classe `pdp--perso-has-photo` qui
     ouvre la galerie epinglee, le `touch-action` de la scene qui autorise le recadrage au doigt,
     le texte d'aide sous l'image, et `est-cadrable`. Sans le bloc, la sortie anticipee laissait
     donc une planche muette et non cadrable. L'etat passe d'abord, les vignettes ensuite.

     ⚠️ ET SUPPRIMER UNE PHOTO RESTE POSSIBLE, sans la croix : remplacer la photo d'une case fait
     quitter la planche a l'ancienne des qu'aucune case ne la montre plus (voir `retirePhoto`
     appelee depuis l'import). C'est ce qui rend la bande retirable sans perdre le geste. */
  function majPile() {
    if (racine) racine.classList.toggle("pdp--perso-has-photo", photos.length > 0);
    scene.style.touchAction = photos.length ? "none" : "auto";
    /* Aide au cadrage sous la galerie : reprise telle quelle de la perso. Visible
       dès qu'une photo est posée, texte selon l'appareil, et elle reste. */
    var aide = document.querySelector("[data-pdp-cadre-aide]");
    if (aide) {
      aide.hidden = !photos.length;
      if (photos.length) {
        var tactile = false;
        try { tactile = window.matchMedia("(hover: none) and (pointer: coarse)").matches; }
        catch (e) { tactile = "ontouchstart" in window; }
        var t = aide.getAttribute(tactile ? "data-aide-tactile" : "data-aide-souris");
        if (t) aide.textContent = t;
      }
    }
    if (interne) interne.classList.toggle("est-cadrable", photos.length > 0);
    /* La bande de vignettes n'existe plus dans le gabarit : tout ce qui suit ne sert qu'aux
       pages qui la portent encore, le temps qu'un cache de section expire. */
    if (!pile) return;
    Array.prototype.slice.call(pile.querySelectorAll(".pelemele-vignette")).forEach(function (v) { v.remove(); });
    photos.forEach(function (p, k) {
      var v = document.createElement("div");
      v.className = "pelemele-vignette";
      v.style.backgroundImage = "url('" + p.url + "')";
      var x = document.createElement("button");
      x.type = "button"; x.textContent = "×";
      x.setAttribute("aria-label", (T.remove || "Retirer") + " " + (k + 1));
      x.addEventListener("click", function () { retirePhoto(k); });
      v.appendChild(x);
      pile.insertBefore(v, boutonAjout);
    });
    if (compteEl) {
      compteEl.hidden = !photos.length;
      compteEl.textContent = photos.length + " " + (T.added || "photos");
    }
  }
  function retirePhoto(k) {
    var p = photos[k];
    if (p) try { URL.revokeObjectURL(p.url); } catch (e) {}
    photos.splice(k, 1);
    var suivantManuel = {};
    Object.keys(manuel).forEach(function (i) {
      var v = manuel[i];
      if (v === null) { suivantManuel[i] = null; return; }
      if (typeof v !== "number") return;
      if (v === k) return;                   // repasse en automatique
      suivantManuel[i] = v > k ? v - 1 : v;
    });
    manuel = suivantManuel;
    deselectionne();
    majPile(); planifie(); majCtaColle(); majCtaRendu(); persiste();
  }
  /* Le bandeau sticky garde son libellé perso tant que product.js ne voit pas de photo :
     dès qu'une photo collage existe, on lui rend le libellé d'ajout. */
  function majCtaColle() {
    var b = $("#pdp-sticky-add");
    if (!b) return;
    var libelle = photos.length ? b.getAttribute("data-label-add") : b.getAttribute("data-label-perso");
    if (libelle) b.textContent = libelle;
  }
  document.addEventListener("change", function () { majCtaColle(); majCtaRendu(); });

  /* ---- Zone : gabarits, cases, style, nombre, textes ---- */
  function vignetteGabarit(gid) {
    var c = document.createElement("canvas");
    c.width = 68; c.height = 98;
    var g = c.getContext("2d");
    g.fillStyle = "#ffffff"; g.fillRect(0, 0, 68, 98);
    /* Aplats doux : trois sables et UN cuivre. Un gris unique rendait les sept vignettes
       interchangeables, et la mise en page ne se lisait qu'au libelle. Le cuivre ne tombe
       que sur une case par vignette, sinon il cesse d'attirer l'oeil (Adrien, 03/08/2026). */
    /* Trait, et un seul accent. Toutes les cases en trait d'encre attenue, sauf UNE remplie
       de cuivre : sept vignettes d'un meme gris etaient interchangeables, sept vignettes tout
       en cuivre ne le seraient pas moins. L'accent ne vaut que s'il est rare, et il tombe au
       milieu de la liste pour rester au centre optique (Adrien, 03/08/2026).
       Le demi-pixel : un trait de 1 px pose sur un entier se repartit sur deux colonnes et
       sort gris et flou. */
    var TRAIT = "rgba(30,34,53,.38)", CUIVRE = "#b5764a";
    g.fillStyle = TRAIT; g.strokeStyle = TRAIT; g.lineWidth = 1;
    function cases(liste) {
      var k = Math.floor(liste.length / 2);
      liste.forEach(function (cc, i) {
        var x = cc[0] * 68 + 0.6, y = cc[1] * 98 + 0.6;
        var w = Math.max(1, cc[2] * 68 - 1.2), h = Math.max(1, cc[3] * 98 - 1.2);
        if (i === k) { g.fillStyle = CUIVRE; g.fillRect(x, y, w, h); g.fillStyle = TRAIT; }
        else g.strokeRect(Math.round(x) + 0.5, Math.round(y) + 0.5, Math.round(w), Math.round(h));
      });
    }
    /* Une suite de glyphes centree, dont un seul en cuivre. `textAlign` est passe a
       gauche par l'appelant : on mesure pour recentrer l'ensemble a la main. */
    function accentue(glyphes, k, cx, cy) {
      var large = 0, i;
      for (i = 0; i < glyphes.length; i++) large += g.measureText(glyphes[i]).width;
      var x = cx - large / 2;
      for (i = 0; i < glyphes.length; i++) {
        g.fillStyle = i === k ? CUIVRE : TRAIT;
        g.fillText(glyphes[i], x, cy);
        x += g.measureText(glyphes[i]).width;
      }
      g.fillStyle = TRAIT;
    }
    if (gid === "lettres") {
      /* Les vignettes en glyphes ne passent pas par `cases()` : sans ce traitement elles
         restaient les seules sans accent. On pose les lettres une a une pour n'en cuivrer
         qu'UNE, au milieu, comme la case accentuee des autres vignettes. */
      g.font = "900 24px " + LETTRES;
      g.textAlign = "left"; g.textBaseline = "middle";
      accentue(["A", "B", "C"], 1, 34, 46);
    } else if (gid === "nombre") {
      g.font = "700 44px " + CHIFFRES;
      g.textAlign = "left"; g.textBaseline = "middle";
      accentue(["3", "0"], 1, 34, 42);
      g.fillStyle = TRAIT;
      g.textAlign = "center";
      g.font = "400 11px " + SCRIPT;
      g.fillText("abc", 34, 72);
    } else if (gid === "grille") {
      g.fillRect(16, 8, 36, 1.5);
      g.fillRect(16, 16, 36, 1.5);
      cases(geometrieGrille(30, "filets"));
    } else if (gid === "lignes") {
      /* ⛔ TOUT GABARIT DOIT AVOIR SA BRANCHE ICI. Sans elle la vignette reste un cadre
         blanc, et le client choisit une mise en page sans la voir : c'est ce qu'a montré
         « Lignes » a sa sortie (Adrien, 03/08/2026). On dessine le nombre par defaut. */
      cases(geometrieLignes(COMPTES_DEF.lignes));
    } else if (gid === "decalee") {
      cases(geometrieDecalee(6));
    } else if (gid === "coeur") {
      g.save();
      g.translate(8, 23);
      traceCoeur(g, 52, 52);
      g.fillStyle = CUIVRE;
      g.fill();
      g.restore();
    } else if (gid === "damier-love") {
      var geo = geometrieDamier("LOVE");
      cases(geo.photos);
      g.strokeStyle = "#d9d5cd";
      geo.lettres.forEach(function (cc) {
        g.strokeRect(cc.x * 68 + 1, cc.y * 98 + 1, cc.w * 68 - 2, cc.h * 98 - 2);
      });
    }
    return c;
  }
  var barre = $("#pelemele-gabarits");
  function majBarre() {
    if (!barre) return;
    Array.prototype.slice.call(barre.querySelectorAll("button")).forEach(function (b) {
      b.classList.toggle("is-on", b.getAttribute("data-gabarit") === etat.gabarit);
      b.setAttribute("aria-pressed", b.getAttribute("data-gabarit") === etat.gabarit ? "true" : "false");
    });
  }
  if (barre) GABARITS.forEach(function (gdef) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "pelemele-gabarit";
    b.setAttribute("data-gabarit", gdef.id);
    b.title = gdef.nom;
    b.appendChild(vignetteGabarit(gdef.id));
    var lab = document.createElement("span");
    lab.textContent = gdef.nom;
    b.appendChild(lab);
    b.addEventListener("click", function () {
      if (etat.gabarit === gdef.id) return;
      etat.gabarit = gdef.id;
      manuel = {}; cadrage = {};
      deselectionne();
      majBarre(); majZone(); planifie(); persiste();
      /* ⛔ LE TITRE SUIT LA MISE EN PAGE CHOISIE (Adrien, 12/08/2026 : « le titre du produit ne
         s'adapte pas au layout selectionne, il semble fige par le parametre d'url »). ?titre=
         nomme la page a l'arrivee, pour dire au client qu'il ne s'est pas trompe de lien ;
         des qu'il choisit une AUTRE mise en page, ce nom devient faux. Le nouveau se compose
         des libelles deja traduits du selecteur : « Pele-mele » + le nom du gabarit, dans la
         langue de la page. Le <title> suit, meme separateur que partout (fromCharCode : la
         regle du depot interdit d'ecrire un demi-cadratin dans le code). */
      var h1 = document.getElementById("pdp-title");
      var nomTitre = (T.carte || "P\u00eale-m\u00eale") + " " + gdef.nom;
      if (h1) h1.textContent = nomTitre;
      try {
        var sep = " " + String.fromCharCode(8211) + " ";
        var iSep = document.title.indexOf(sep);
        document.title = nomTitre + (iSep >= 0 ? document.title.slice(iSep) : "");
      } catch (eT) {}
    });
    barre.appendChild(b);
  });

  var nombreBloc = $("#pelemele-nombre-bloc");
  var nombreInput = $("#pelemele-nombre");
  if (nombreInput) {
    nombreInput.value = nombreActuel();
    nombreInput.addEventListener("input", function () {
      var v = String(nombreInput.value).replace(/\D/g, "").slice(0, 2);
      if (v !== nombreInput.value) nombreInput.value = v;
      etat.nombre = v;
      manuel = {}; cadrage = {}; cacheRef = null;
      planifie(); persiste();
    });
  }
  /* Stepper, pas de saisie : taper un chiffre au clavier mobile est une purge
     (Adrien, 03/08/2026). Le pas suit le gabarit (2 par 2 pour la décalée). */
  var casesBloc = $("#pelemele-cases-bloc");
  var casesVal = $("#pelemele-cases-val");
  function majCases() {
    if (!casesVal || !COMPTES_LIM[cleCompte()]) return;
    casesVal.textContent = etat.gabarit === "coeur" ? coeurTotal()
      : etat.gabarit === "lettres" ? lettresRef().total : compte(cleCompte());
  }
  function bougeCases(sens) {
    var lim = COMPTES_LIM[cleCompte()];
    if (!lim) return;
    var v;
    var aPaliers = etat.gabarit === "coeur" || etat.gabarit === "lettres";
    if (aPaliers) {
      /* ⛔ Les paliers du cœur et du mot sont les comptes RÉELLEMENT découpables :
         un pas vers 5, 8 ou 10 ne changeait rien quand la découpe la plus proche
         restait la même (Adrien, 03/08/2026). Le stepper saute de découpe en
         découpe. */
      var dispo = etat.gabarit === "lettres" ? lettresComptesDisponibles() : coeurComptesDisponibles();
      var courant = etat.gabarit === "lettres" ? lettresRef().total : coeurTotal();
      var ix = dispo.indexOf(courant);
      if (ix === -1) for (var di = 0; di < dispo.length; di++) {
        if (ix === -1 || Math.abs(dispo[di] - courant) < Math.abs(dispo[ix] - courant)) ix = di;
      }
      v = dispo[Math.max(0, Math.min(dispo.length - 1, ix + sens))];
    } else {
      v = Math.max(lim[0], Math.min(lim[1], compte(cleCompte()) + sens * lim[2]));
    }
    if (v === compte(cleCompte())) return;
    etat.comptes[cleCompte()] = String(v);
    /* Les index de cases changent de sens : cadrages et choix manuels repartent. */
    manuel = {}; cadrage = {};
    deselectionne();
    majCases(); planifie(); persiste();
  }
  $("#pelemele-cases-moins") && $("#pelemele-cases-moins").addEventListener("click", function () { bougeCases(-1); });
  $("#pelemele-cases-plus") && $("#pelemele-cases-plus").addEventListener("click", function () { bougeCases(1); });
  var styleBloc = $("#pelemele-style-bloc");
  function majStyles() {
    if (!styleBloc) return;
    Array.prototype.slice.call(styleBloc.querySelectorAll("[data-pelemele-style]")).forEach(function (b) {
      var on = b.getAttribute("data-pelemele-style") === etat.texteStyle;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  styleBloc && styleBloc.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-pelemele-style]") : null;
    if (!b) return;
    var avantCompte = compte("grille");
    etat.texteStyle = b.getAttribute("data-pelemele-style");
    if (compte("grille") !== avantCompte) { manuel = {}; cadrage = {}; deselectionne(); }
    majStyles(); majZone(); planifie(); persiste();
  });
  function majCoeurStyles() {
    Array.prototype.slice.call(document.querySelectorAll("[data-pelemele-coeur-style]")).forEach(function (b) {
      var on = b.getAttribute("data-pelemele-coeur-style") === coeurStyle();
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function majDecaleeStyles() {
    Array.prototype.slice.call(document.querySelectorAll("[data-pelemele-decalee-style]")).forEach(function (b) {
      var on = b.getAttribute("data-pelemele-decalee-style") === decaleeStyle();
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  var decaleeStylesBloc = document.getElementById("pelemele-decalee-styles");
  decaleeStylesBloc && decaleeStylesBloc.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-pelemele-decalee-style]") : null;
    if (!b) return;
    etat.decaleeStyle = b.getAttribute("data-pelemele-decalee-style");
    /* Les deux styles n'ont ni le même découpage ni le même compte : les choix
       de photo et les cadrages repartent, comme au changement de style du cœur. */
    manuel = {}; cadrage = {};
    deselectionne();
    majDecaleeStyles(); majZone(); planifie(); persiste();
  });
  var coeurStylesBloc = document.getElementById("pelemele-coeur-styles");
  coeurStylesBloc && coeurStylesBloc.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-pelemele-coeur-style]") : null;
    if (!b) return;
    etat.coeurStyle = b.getAttribute("data-pelemele-coeur-style");
    manuel = {}; cadrage = {};
    majCoeurStyles(); majZone(); planifie(); persiste();
  });
  /* ---- Style de l'affiche : police, fond, encre ---- */
  function majStyleAffiche() {
    Array.prototype.slice.call(document.querySelectorAll("[data-pelemele-police]")).forEach(function (b) {
      var on = b.getAttribute("data-pelemele-police") === etat.police;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    Array.prototype.slice.call(document.querySelectorAll("[data-pelemele-fond]")).forEach(function (b) {
      var on = b.getAttribute("data-pelemele-fond") === etat.fond;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var bp = e.target.closest("[data-pelemele-police]");
    var bf = e.target.closest("[data-pelemele-fond]");
    if (!bp && !bf) return;
    if (bp) {
      var pv = bp.getAttribute("data-pelemele-police");
      etat.police = etat.police === pv ? null : pv;   // re-clic = retour automatique
      chargePolices();
    } else {
      etat.fond = bf.getAttribute("data-pelemele-fond");
    }
    /* ⛔ ET LES PASTILLES SUIVENT LE FOND. `encreChamp` retombe sur la creme des fonds sombres :
       sans ce rappel, changer de fond laissait les pastilles sur la couleur d'avant pendant que
       l'affiche ecrivait dans l'autre. Meme defaut que sur le panneau de mariage et sur l'affiche
       personnalisee, trouve le meme jour dans les trois configurateurs. */
    majStyleAffiche(); majPastilles(); planifie(); persiste();
  });

  var textesBloc = $("#pelemele-textes-bloc");
  var textesZone = $("#pelemele-textes");
  function majZone() {
    var gb = gabarit();
    if (nombreBloc) nombreBloc.hidden = gb.id !== "nombre";
    var lim = COMPTES_LIM[cleCompte()];
    if (casesBloc) casesBloc.hidden = !lim;
    majCases();
    var blocStyleCoeur = document.getElementById("pelemele-coeur-style-bloc");
    if (blocStyleCoeur) blocStyleCoeur.hidden = gb.id !== "coeur";
    majCoeurStyles();
    var blocStyleDecalee = document.getElementById("pelemele-decalee-style-bloc");
    if (blocStyleDecalee) blocStyleDecalee.hidden = gb.id !== "decalee";
    majDecaleeStyles();
    if (styleBloc) styleBloc.hidden = gb.id !== "grille";
    var fondBloc = document.getElementById("pelemele-fond-bloc");
    if (fondBloc) fondBloc.hidden = estPleinBord();
    majStyles();
    var champs = champsGabarit();
    if (textesBloc) textesBloc.hidden = !champs.length;
    /* ⛔ ET LE CHOIX DE POLICE SUIT LES CHAMPS (Adrien, 15/08/2026 : « pourquoi le layout lignes
       a des options de police alors qu'il n'y a pas de texte ? »). Il n'y a pas deux regles :
       une police ne sert qu'a dessiner un texte, donc le bloc vit et meurt avec les champs, sur
       le MEME test que le bloc des textes. Deux conditions separees finiraient par diverger.
       ⚠️ LE FOND, LUI, RESTE : il peint l'affiche entiere, texte ou pas. C'est la difference
       entre un reglage du SUPPORT et un reglage du TEXTE, et elle vaut pour les sept gabarits. */
    var policeBloc = document.getElementById("pelemele-police-bloc");
    if (policeBloc) policeBloc.hidden = !champs.length;
    if (!textesZone) return;
    textesZone.innerHTML = "";
    champs.forEach(function (champ) {
      /* La rangée du champ porte SA pastille d'encre à droite, comme la perso. */
      var rangee = document.createElement("div");
      rangee.className = "pelemele-champ";
      var input = document.createElement("input");
      input.type = "text";
      input.maxLength = champ.max || 40;
      input.placeholder = champ.ph || champ.defaut || "";
      input.autocomplete = "off";
      var courant = (etat.textes[gb.id] || {})[champ.cle];
      if (courant != null) input.value = courant;
      input.addEventListener("input", function () {
        if (!etat.textes[gb.id]) etat.textes[gb.id] = {};
        etat.textes[gb.id][champ.cle] = input.value;
        /* Un champ qui change la géométrie (lettres du damier) rebat les cases. */
        if (champ.geometrie) { manuel = {}; cadrage = {}; selection = -1; majCases(); }
        planifie(); persiste();
      });
      rangee.appendChild(input);
      /* ⛔ L'OEIL, ENTRE LE CHAMP ET LA PASTILLE (Adrien, 15/08/2026 : « certains clients ne
         veulent pas tous les textes »). Il se pose ICI, en JS, parce que les champs du
         pele-mele sont CONSTRUITS PAR CE FICHIER : `#pelemele-textes` est un div vide dans le
         gabarit. J'ai d'abord pose l'oeil dans main-product.liquid, sur les champs de l'affiche
         personnalisee, qui ressemblent aux siens a l'ecran et n'ont rien a voir dans le code.
         Deux configurateurs qui se ressemblent ne partagent pas leur balisage : c'est la
         confusion qui a coute trois corrections invisibles.
         ⚠️ IL NE VIDE PAS LE CHAMP : l'etat vit sur `masque`, a cote de la valeur, et le dessin
         saute le texte. Le client retrouve son texte en reaffichant. */
      /* ⛔ SAUF QUAND LE TEXTE EST LE DESSIN (Adrien, serie 322 : « vire l'oeil pour masquer le
         texte dans le layout damier lettre, ça n'a aucun sens »).

         `geometrie: true` marque le champ dont les lettres DECOUPENT la planche : le mot du
         damier (« LOVE ») et celui de « Mot en photos » (« DAD »). Le masquer ne cache pas un
         texte pose sur l'affiche, il retire la forme dans laquelle les photos sont rangees.
         Le clic sur l'oeil appelait d'ailleurs `majCases()` par la meme branche que la saisie :
         il rebattait toutes les cases sur un mot vide, donc rendait une planche sans forme,
         sans photo placee, et sans rien a l'ecran qui explique pourquoi.

         La condition ne nomme pas le gabarit : elle lit la propriete qui dit ce que le champ
         FAIT. Un gabarit ajoute demain avec un texte porteur de geometrie n'aura pas d'oeil non
         plus, sans qu'on ait a y penser.

         ⚠️ ET ON EFFACE LE DRAPEAU DEJA ENREGISTRE. La session garde `<cle>__masque`, et le
         dessin l'honore ligne 230 quel que soit le bouton : un client qui avait masque son mot
         AVANT ce correctif serait reste avec une planche vide et plus aucun moyen de revenir,
         puisque l'oeil qui servait a annuler vient de disparaitre. */
      if (champ.geometrie) {
        if (etat.textes[gb.id]) delete etat.textes[gb.id][champ.cle + "__masque"];
      } else {
      var oeil = document.createElement("button");
      oeil.type = "button";
      oeil.className = "perso-text__oeil sans";
      oeil.setAttribute("data-pelemele-oeil", champ.cle);
      var masqueDepart = !!(etat.textes[gb.id] && etat.textes[gb.id][champ.cle + "__masque"]);
      oeil.setAttribute("aria-pressed", masqueDepart ? "true" : "false");
      oeil.title = T.masquer || "Masquer ce texte sur l'affiche";
      oeil.setAttribute("aria-label", oeil.title);
      oeil.innerHTML = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
        + ' stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6Z"/>'
        + '<circle cx="12" cy="12" r="2.6"/></svg>';
      oeil.addEventListener("click", function () {
        var on = oeil.getAttribute("aria-pressed") === "true";
        oeil.setAttribute("aria-pressed", on ? "false" : "true");
        if (!etat.textes[gb.id]) etat.textes[gb.id] = {};
        etat.textes[gb.id][champ.cle + "__masque"] = !on;
        planifie(); persiste();
      });
      rangee.appendChild(oeil);
      }
      /* ⛔ LE BOUTON DE POLICE SE POSE ENTRE L'OEIL ET LA PASTILLE, le meme ordre que sur le
         panneau et sur l'affiche personnalisee : on ecrit, on montre ou non, on choisit la
         lettre, on choisit l'encre. Trois configurateurs, un seul geste a apprendre.

         ⛔ MAIS PAS QUAND IL N'Y A QU'UN SEUL TEXTE (Adrien, 20/08/2026 : « dans les variantes
         qui ont un seul champ de texte, ça n'a aucun sens de mettre aussi la pastille de police
         a droite du texte »). La pastille sert a donner a UN texte une lettre differente de
         celle des autres ; seul, il n'a personne dont se distinguer, et le bloc de police
         au-dessus, qui reste affiche, fait deja exactement la meme chose. Deux commandes pour un
         seul reglage, dont l'une cachee derriere une fenetre.

         La condition compte les CHAMPS, elle ne nomme aucun gabarit : « grille decalee » et
         « damier LOVE » sont les deux d'aujourd'hui, un gabarit ajoute demain avec un texte
         unique n'aura pas de pastille non plus, sans qu'on ait a y penser. Meme raison que le
         bloc de police, qui vit et meurt avec les champs. */
      if (champs.length > 1) {
      var pol = document.createElement("button");
      pol.type = "button";
      pol.className = "perso-text__font-pick sans";
      pol.setAttribute("data-pelemele-police-champ", champ.cle);
      pol.title = T.police || "Police";
      pol.setAttribute("aria-label", pol.title);
      pol.setAttribute("aria-haspopup", "dialog");
      var ex = document.createElement("span");
      ex.className = "perso-text__font-ex";
      ex.textContent = "Aa";
      pol.appendChild(ex);
      pol.addEventListener("click", function () { ouvreModalePolice(champ.cle); });
      rangee.appendChild(pol);
      } else if (etat.polices[champ.cle]) {
        /* ⛔ ET ON EFFACE LE REGLAGE DEJA ENREGISTRE, comme pour l'oeil du damier. Un client qui
           avait choisi une police pour ce champ AVANT ce correctif garderait son choix applique
           et plus aucun moyen d'en changer : le bloc de police au-dessus resterait sans effet,
           puisque le reglage par champ le bat. Un reglage qu'on ne peut plus atteindre est pire
           qu'un reglage absent. */
        delete etat.polices[champ.cle];
        persiste();
      }

      var past = document.createElement("button");
      past.type = "button";
      past.className = "perso-text__ink sans";
      past.setAttribute("data-pelemele-encre-champ", champ.cle);
      past.title = T.encre || "Couleur du texte";
      past.setAttribute("aria-label", T.encre || "Couleur du texte");
      past.setAttribute("aria-haspopup", "dialog");
      var pastille = document.createElement("span");
      pastille.className = "perso-text__swatch";
      past.appendChild(pastille);
      past.addEventListener("click", function () { ouvreModaleEncre(champ.cle); });
      rangee.appendChild(past);
      textesZone.appendChild(rangee);
    });
    majPastilles(); majPastillesPolice();
  }
  /* Pastilles : chacune montre l'encre effective de son champ. */
  function majPastilles() {
    Array.prototype.slice.call(document.querySelectorAll("[data-pelemele-encre-champ]")).forEach(function (b) {
      var sw = b.querySelector(".perso-text__swatch");
      if (sw) sw.style.background = encreChamp(b.getAttribute("data-pelemele-encre-champ"), "#1d1d1b");
    });
  }
  /* Modale d'encre : la palette de la perso, un champ à la fois. Re-cliquer la
     teinte active revient à l'automatique. */
  /* La police d'UN texte. Meme fenetre et meme geste que l'encre : deux voisins qui
     ouvriraient deux formes differentes obligeraient a apprendre deux fois la meme chose. */
  var modalePolice = null, champPoliceOuvert = null;
  function majPastillesPolice() {
    Array.prototype.slice.call(document.querySelectorAll("[data-pelemele-police-champ]")).forEach(function (b) {
      var cle = b.getAttribute("data-pelemele-police-champ");
      var ex = b.querySelector(".perso-text__font-ex");
      if (ex) ex.style.fontFamily = fonte("400", 16, SERIF, null, cle).replace(/^.*?16px /, "");
      b.classList.toggle("is-on", !!etat.polices[cle]);
    });
  }
  function ouvreModalePolice(cle) {
    champPoliceOuvert = cle;
    if (!modalePolice) {
      modalePolice = document.createElement("div");
      modalePolice.className = "perso-ink-modal pelemele-ink-modal";
      modalePolice.setAttribute("role", "dialog");
      modalePolice.setAttribute("aria-modal", "true");
      var pan = document.createElement("div");
      pan.className = "perso-ink-modal__panel sans";
      var tete = document.createElement("div");
      tete.className = "perso-ink-modal__head";
      var t = document.createElement("span");
      t.textContent = T.police || "Police";
      var x = document.createElement("button");
      x.type = "button"; x.className = "perso-ink-modal__x"; x.textContent = "\u00d7";
      x.setAttribute("aria-label", T.fermer || "Fermer");
      x.addEventListener("click", function () { modalePolice.hidden = true; });
      tete.appendChild(t); tete.appendChild(x);
      pan.appendChild(tete);
      var grille = document.createElement("div");
      grille.className = "perso-modale-polices";
      Object.keys(POLICES).forEach(function (id) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "perso-text__font";
        b.setAttribute("data-pelemele-modale-police", id);
        b.style.fontFamily = POLICES[id];
        b.textContent = "Aa";
        b.addEventListener("click", function () {
          /* Recliquer la police posee la retire : ce texte reprend celle de la planche. */
          if (etat.polices[champPoliceOuvert] === id) delete etat.polices[champPoliceOuvert];
          else etat.polices[champPoliceOuvert] = id;
          majModalePolice(); majPastillesPolice(); persiste();
          chargePolices().then(function () { planifie(); });
        });
        grille.appendChild(b);
      });
      pan.appendChild(grille);
      modalePolice.appendChild(pan);
      modalePolice.addEventListener("click", function (e) {
        if (e.target === modalePolice) modalePolice.hidden = true;
      });
      document.body.appendChild(modalePolice);
    }
    majModalePolice();
    modalePolice.hidden = false;
  }
  function majModalePolice() {
    if (!modalePolice) return;
    Array.prototype.slice.call(modalePolice.querySelectorAll("[data-pelemele-modale-police]")).forEach(function (b) {
      var on = etat.polices[champPoliceOuvert] === b.getAttribute("data-pelemele-modale-police");
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  var modaleEncre = null, champEncreOuvert = null;
  function ouvreModaleEncre(cle) {
    champEncreOuvert = cle;
    if (!modaleEncre) {
      modaleEncre = document.createElement("div");
      modaleEncre.className = "perso-ink-modal pelemele-ink-modal";
      modaleEncre.setAttribute("role", "dialog");
      modaleEncre.setAttribute("aria-modal", "true");
      var panneau = document.createElement("div");
      panneau.className = "perso-ink-modal__panel sans";
      var tete = document.createElement("div");
      tete.className = "perso-ink-modal__head";
      var titre = document.createElement("span");
      titre.textContent = T.encre || "Couleur du texte";
      var fermer = document.createElement("button");
      fermer.type = "button";
      fermer.className = "perso-ink-modal__x";
      fermer.textContent = "×";
      fermer.setAttribute("aria-label", T.fermer || "Fermer");
      fermer.addEventListener("click", fermeModaleEncre);
      tete.appendChild(titre); tete.appendChild(fermer);
      panneau.appendChild(tete);
      var grille = document.createElement("div");
      grille.className = "perso-text__color-grid";
      Object.keys(MATS).forEach(function (mat) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "perso-text__color";
        b.setAttribute("data-pelemele-modale-encre", mat);
        var sw = document.createElement("span");
        sw.className = "perso-text__swatch";
        sw.style.background = MATS[mat];
        b.appendChild(sw);
        b.addEventListener("click", function () {
          var gab = etat.gabarit;
          if (!etat.encres[gab]) etat.encres[gab] = {};
          if (etat.encres[gab][champEncreOuvert] === mat) delete etat.encres[gab][champEncreOuvert];
          else etat.encres[gab][champEncreOuvert] = mat;
          majModaleEncre(); majPastilles(); planifie(); persiste();
        });
        grille.appendChild(b);
      });
      panneau.appendChild(grille);
      modaleEncre.appendChild(panneau);
      modaleEncre.addEventListener("click", function (e) { if (e.target === modaleEncre) fermeModaleEncre(); });
      document.body.appendChild(modaleEncre);
    }
    majModaleEncre();
    modaleEncre.hidden = false;
  }
  function fermeModaleEncre() { if (modaleEncre) modaleEncre.hidden = true; champEncreOuvert = null; }
  function majModaleEncre() {
    if (!modaleEncre) return;
    var choix = champEncreOuvert ? encreDuChamp(champEncreOuvert) : null;
    Array.prototype.slice.call(modaleEncre.querySelectorAll("[data-pelemele-modale-encre]")).forEach(function (b) {
      b.classList.toggle("is-on", b.getAttribute("data-pelemele-modale-encre") === choix);
    });
  }

  /* ---- Gestes sur la scène ---- */
  function caseAuPoint(px, py, r) {
    var gb = gabarit();
    if (gb.id === "nombre" || gb.id === "coeur" || gb.id === "lettres") {
      var formes = tuilesEcran(r.width, r.height) || [];
      for (var f = 0; f < formes.length; f++) {
        var q = formes[f];
        if (q.diamant) {
          if (Math.abs(px - q.cx) + Math.abs(py - q.cy) <= q.rr) return f;
          var pris = false;
          (q.absorbes || []).forEach(function (d) {
            if (Math.abs(px - q.cx - d[0]) + Math.abs(py - q.cy - d[1]) <= q.rr) pris = true;
          });
          if (pris) return f;
        }
        else if (px >= q.x && px <= q.x + q.w && py >= q.y && py <= q.y + q.h) return f;
      }
      return -2;
    }
    var cases_ = casesCourantes();
    for (var i = 0; i < cases_.length; i++) {
      var c = cases_[i];
      if (px >= c[0] * r.width && px <= (c[0] + c[2]) * r.width
        && py >= c[1] * r.height && py <= (c[1] + c[3]) * r.height) return i;
    }
    return -1;
  }
  var doigts = {}, panActif = null, pinceActive = null, survol = -1;
  scene.addEventListener("pointerleave", function () {
    if (survol !== -1) { survol = -1; scene.style.cursor = ""; planifie(); }
  });
  /* ⛔ APPUI LONG PUIS GLISSEMENT : DEPLACER UNE PHOTO D'UNE CASE A L'AUTRE (Adrien,
     15/08/2026 : « on ne peut pas deplacer une image en restant appuye dessus et en la
     deplacant dans la grille »). Le glissement court sert deja au CADRAGE (« glissez la photo
     pour la cadrer ») : les deux gestes partent du meme doigt, sur la meme case, et seul le
     TEMPS peut les separer. 420 ms d'immobilite ouvrent le deplacement ; un mouvement avant ce
     delai reste un cadrage, exactement comme avant.

     ⛔ ET LE DEFILEMENT DOIT LACHER PRISE, SINON LE GESTE MEURT EN ROUTE. La scene est en
     `touch-action: pan-y pinch-zoom`, choix assume pour garder le zoom natif a deux doigts :
     laisse tel quel, le premier mouvement vertical serait pris par la page et le navigateur
     ANNULERAIT le pointeur au milieu du deplacement. On coupe donc le defilement AU MOMENT DE
     LA PRISE, pendant que le doigt est encore immobile et qu'aucune intention de defilement
     n'est encore arbitree, et par les deux voies : `touch-action:none` sur la scene, et un
     `touchmove` non passif qui refuse. La seconde est celle qui tient sur iOS. */
  var deplacement = null, minuteriePrise = 0;
  function annulePrise() { if (minuteriePrise) { clearTimeout(minuteriePrise); minuteriePrise = 0; } }
  function finDeplacement() {
    annulePrise();
    if (!deplacement) return;
    deplacement = null;
    scene.style.touchAction = "";
    planifie();
  }
  scene.addEventListener("touchmove", function (e) {
    if (deplacement && e.cancelable) e.preventDefault();
  }, { passive: false });
  function echangeCases(a, b) {
    if (a === b || !(a >= 0) || !(b >= 0)) return;
    /* ⛔ LE VISIBLE DEVIENT EXPLICITE AVANT L'ECHANGE. Les cases laissees en affectation
       automatique se recalculent a chaque lecture : echanger deux entrees sans figer les
       autres ferait bouger des cases auxquelles personne n'a touche. C'est le meme defaut que
       « ca modifie plusieurs cases », deja ferme a l'import le 03/08/2026. */
    affectations().forEach(function (pi, c) { if (pi >= 0) manuel[c] = pi; });
    var pa = manuel[a], pb = manuel[b];
    /* ⚠️ UNE CASE D'ARRIVEE VIDE REND LA CASE DE DEPART AU FLUX AUTOMATIQUE, elle ne la marque
       pas « retiree ». Marquee, elle refuserait le prochain import fait depuis le CTA, et le
       client verrait sa photo apparaitre ailleurs que dans le trou qu'il vient de creer. */
    if (pb === undefined) delete manuel[a]; else manuel[a] = pb;
    if (pa === undefined) delete manuel[b]; else manuel[b] = pa;
    var ka = cadrage[a], kb = cadrage[b];
    if (kb === undefined) delete cadrage[a]; else cadrage[a] = kb;
    if (ka === undefined) delete cadrage[b]; else cadrage[b] = ka;
  }
  scene.addEventListener("pointerdown", function (e) {
    var r = scene.getBoundingClientRect();
    var px = e.clientX - r.left, py = e.clientY - r.top;
    doigts[e.pointerId] = { x: px, y: py };
    var ids = Object.keys(doigts);
    if (ids.length === 2) {
      /* Un second doigt est un pincement, jamais un deplacement : la prise est rendue. */
      annulePrise();
      finDeplacement();
      var a = doigts[ids[0]], b = doigts[ids[1]];
      var i = caseAuPoint((a.x + b.x) / 2, (a.y + b.y) / 2, r);
      if (i >= 0 && affectations()[i] >= 0) {
        pinceActive = { i: i, d0: Math.hypot(a.x - b.x, a.y - b.y), z0: reglage(i).z };
        panActif = null;
      }
      return;
    }
    var i2 = caseAuPoint(px, py, r);
    if (i2 >= 0 && affectations()[i2] >= 0) {
      panActif = { i: i2, x: px, y: py, bouge: false };
      try { scene.setPointerCapture(e.pointerId); } catch (err) {}
      /* La prise ne s'arme que sur une case PLEINE : il n'y a rien a deplacer ailleurs. */
      annulePrise();
      minuteriePrise = setTimeout(function () {
        minuteriePrise = 0;
        if (!panActif || pinceActive) return;
        deplacement = { i: panActif.i, cible: panActif.i };
        panActif = null;               /* la meme case ne peut pas se cadrer ET se deplacer */
        scene.style.touchAction = "none";
        try { navigator.vibrate && navigator.vibrate(12); } catch (err2) {}
        planifie();
      }, 420);
    }
  });
  scene.addEventListener("pointermove", function (e) {
    var r = scene.getBoundingClientRect();
    var px = e.clientX - r.left, py = e.clientY - r.top;
    if (doigts[e.pointerId]) doigts[e.pointerId] = { x: px, y: py };
    /* Photo en main : le doigt ne recadre plus rien, il DESIGNE une case d'arrivee. */
    if (deplacement) {
      var ic = caseAuPoint(px, py, r);
      if (ic !== deplacement.cible) { deplacement.cible = ic; planifie(); }
      return;
    }
    /* Survol (souris) : la case qui serait modifiée s'entoure de cuivre. */
    if (!panActif && !pinceActive && e.pointerType !== "touch") {
      var iSurvol = caseAuPoint(px, py, r);
      if (iSurvol !== survol) {
        survol = iSurvol;
        scene.style.cursor = iSurvol >= 0 || iSurvol === -2 ? "pointer" : "";
        planifie();
      }
    }
    if (pinceActive) {
      var ids = Object.keys(doigts);
      if (ids.length >= 2) {
        var a = doigts[ids[0]], b = doigts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        var reg = reglage(pinceActive.i);
        cadrage[pinceActive.i] = { dx: reg.dx, dy: reg.dy, z: Math.max(1, Math.min(3, pinceActive.z0 * d / Math.max(1, pinceActive.d0))) };
        planifie();
      }
      return;
    }
    if (!panActif) return;
    var ddx = px - panActif.x, ddy = py - panActif.y;
    if (!panActif.bouge && Math.hypot(ddx, ddy) < 4) return;
    /* Le doigt a bouge avant les 420 ms : c'est un cadrage, la prise n'aura pas lieu. */
    annulePrise();
    panActif.bouge = true;
    var cases_ = casesCourantes(), c = cases_[panActif.i];
    var p = photos[affectations()[panActif.i]];
    if (!c || !p) return;
    var w = c[2] * r.width, h = c[3] * r.height;
    var reg2 = reglage(panActif.i);
    var s = Math.max(w / p.w, h / p.h) * reg2.z;
    var jeuX = p.w * s - w, jeuY = p.h * s - h;
    cadrage[panActif.i] = {
      dx: jeuX > 1 ? Math.max(0, Math.min(1, reg2.dx + ddx / jeuX)) : reg2.dx,
      dy: jeuY > 1 ? Math.max(0, Math.min(1, reg2.dy + ddy / jeuY)) : reg2.dy,
      z: reg2.z
    };
    panActif.x = px; panActif.y = py;
    planifie();
  });
  function finDoigt(e) {
    annulePrise();
    /* ⛔ LE DEPOT SE LIT AU RELACHEMENT, PAS AU DERNIER pointermove. Un doigt leve juste apres
       un mouvement rapide finit souvent hors de la case survolee a la derniere frame ; c'est la
       position de la LEVEE qui fait foi, comme pour un tap. */
    if (deplacement) {
      var rd = scene.getBoundingClientRect();
      var cible = caseAuPoint(e.clientX - rd.left, e.clientY - rd.top, rd);
      var source = deplacement.i;
      delete doigts[e.pointerId];
      finDeplacement();
      if (cible >= 0 && cible !== source) { echangeCases(source, cible); persiste(); }
      planifie();
      return;
    }
    var etaitPan = panActif, etaitPince = pinceActive;
    delete doigts[e.pointerId];
    if (Object.keys(doigts).length < 2) pinceActive = null;
    if (etaitPince) { persiste(); return; }
    if (!etaitPan) {
      /* Tap hors pan : le nombre et le cœur n'ont pas de case unitaire, tout tap
         importe. Une case vide tapée devient la cible du prochain import. */
      var r = scene.getBoundingClientRect();
      var px = e.clientX - r.left, py = e.clientY - r.top;
      var i = caseAuPoint(px, py, r);
      /* ⛔ La case cliquée est ciblée MÊME sans photo importée : verrouillé sur
         photos.length, le premier import partait toujours en case 1 au lieu de
         la case choisie (Adrien, 03/08/2026, cœur). Le fond (-2) reste un ajout
         simple, comme le CTA. */
      if (i === -2) { veutFichier(null); return; }
      if (i >= 0) veutFichier(i);
      return;
    }
    panActif = null;
    if (etaitPan.bouge) { persiste(); return; }
    /* Clic sans glissement sur une case pleine : changer CETTE photo (Adrien,
       03/08/2026). Le sélecteur s'ouvre, le premier fichier choisi la remplace. */
    veutFichier(etaitPan.i);
  }
  /* ⛔ LE SELECTEUR DE FICHIER S'OUVRE DEPUIS UN `click`, JAMAIS DEPUIS UN `pointerup`.
     Adrien, 15/08/2026 : « l'import des photos quand on clique sur les cases du placeholder
     pele-mele ne fonctionne pas sur iPhone », et c'est ce defaut qui a fait perdre une vente
     aux Pays-Bas la veille.

     WebKit n'accorde l'activation par l'utilisateur qui autorise l'ouverture d'un
     `input[type=file]` que depuis certains evenements, et `pointerup` n'en fait pas partie.
     L'appel part, ne leve AUCUNE erreur, et rien ne s'ouvre : ce silence est ce qui a rendu le
     defaut si long a voir, et pourquoi il ressemblait a un probleme de canvas ou de format
     d'image alors qu'il n'en etait pas un.

     ⚠️ LA PREUVE EST DANS CE DEPOT, PAS DANS UNE SUPPOSITION. Trois autres chemins ouvrent le
     MEME input et fonctionnent sur iPhone : le CTA « Importer ma photo » (plus haut dans ce
     fichier), `ajoute()` quand aucune photo n'est encore la, et le placeholder de la fiche
     perso dans product.js. Les trois partent d'un `click`. Le seul qui echoue est le seul en
     `pointerup`. C'est ce contraste qui designe la cause, et non le fait que ce soit un canvas.

     => Le GESTE (pan, pince, tap) continue de se lire sur les evenements pointeur, qui sont les
     bons pour ca ; seule l'OUVERTURE change de porte. Le `click` de compatibilite suit toujours
     un tap immobile, sur iOS comme ailleurs : un seul chemin sert tous les navigateurs, et il
     n'y a pas de branche « si iPhone » a maintenir. */
  var fichierVoulu = null;
  function veutFichier(cible) { fichierVoulu = { cible: cible, t: Date.now() }; }
  scene.addEventListener("pointerup", finDoigt);
  scene.addEventListener("click", function () {
    var v = fichierVoulu;
    fichierVoulu = null;
    /* Une intention perimee appartient a un autre geste : un `click` peut arriver seul, et le
       delai de compatibilite d'iOS ne depasse jamais quelques centaines de millisecondes.
       700 ms le couvre largement sans jamais rouvrir le selecteur sur un geste ancien. */
    if (!v || !fichierInput || Date.now() - v.t > 700) return;
    cibleRemplacement = v.cible;
    fichierInput.click();
  });
  /* ⚠️ UN POINTEUR ANNULE REPOSE LA PHOTO OU ELLE ETAIT, il ne la depose pas. Une annulation
     veut dire que le navigateur a repris le geste : la derniere case visee peut dater, et
     brouiller la planche sur un geste que le client n'a pas termine serait pire que ne rien
     faire. Il la reprend, elle n'a pas bouge. */
  scene.addEventListener("pointercancel", function (e) {
    delete doigts[e.pointerId];
    panActif = null; pinceActive = null;
    finDeplacement();
  });
  scene.addEventListener("wheel", function (e) {
    var r = scene.getBoundingClientRect();
    var i = caseAuPoint(e.clientX - r.left, e.clientY - r.top, r);
    if (i < 0 || affectations()[i] < 0) return;
    e.preventDefault();
    var reg = reglage(i);
    cadrage[i] = { dx: reg.dx, dy: reg.dy, z: Math.max(1, Math.min(3, reg.z * (1 - e.deltaY * 0.002))) };
    planifie();
  }, { passive: false });
  scene.addEventListener("dblclick", function (e) {
    var r = scene.getBoundingClientRect();
    var i = caseAuPoint(e.clientX - r.left, e.clientY - r.top, r);
    if (i >= 0) { delete cadrage[i]; planifie(); persiste(); }
  });

  /* ---- Composition d'impression + panier ---- */
  function chargePolices() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var lots = [
      document.fonts.load('500 24px "Cormorant Garamond"'),
      document.fonts.load('400 24px "Great Vibes"')
    ];
    /* La police choisie doit être chargée avant l'aperçu et l'impression ; les
       polices système (Georgia, Arial...) rendent la promesse sans rien tirer.
       ⛔ TOUTES CELLES QUI SERONT DESSINEES, PAS SEULEMENT CELLE DE LA PLANCHE. Depuis qu'un
       texte peut avoir SA police, `etat.police` ne dit plus a lui seul ce qui sera trace : un
       titre en Cinzel sur une planche en Georgia ne chargeait rien, et le canvas le dessinait
       avec le repli systeme, a l'ecran COMME DANS LE FICHIER D'IMPRESSION. Meme faute que celle
       trouvee sur le panneau de mariage le 20/08/2026, et le banc du theme la refuse desormais. */
    var voulues = {};
    if (etat.police) voulues[etat.police] = true;
    Object.keys(etat.polices || {}).forEach(function (k) { if (etat.polices[k]) voulues[etat.polices[k]] = true; });
    Object.keys(voulues).forEach(function (id) {
      var fam = POLICES[id];
      if (!fam) return;
      ["400", "500", "700"].forEach(function (gr) {
        try { lots.push(document.fonts.load(gr + " 24px " + fam)); } catch (e) {}
      });
    });
    return Promise.all(lots).catch(function () {}).then(function () { return document.fonts.ready; }).catch(function () {});
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { cacheLettres = {}; planifie(); }).catch(function () {});
    /* Une police qui finit de charger après coup invaliderait le scan : on revide. */
    if (document.fonts.addEventListener) {
      document.fonts.addEventListener("loadingdone", function () { cacheLettres = {}; planifie(); });
    }
  }
  function composeImpression() {
    return chargePolices().then(function () {
      var c = document.createElement("canvas");
      c.width = 2200; c.height = 3178;
      dessine(c.getContext("2d"), c.width, c.height, false);
      return new Promise(function (res, rej) {
        c.toBlob(function (b) {
          if (!b) { rej(new Error("toBlob")); return; }
          res(new File([b], "affiche-pele-mele.jpg", { type: "image/jpeg" }));
        }, "image/jpeg", 0.92);
      });
    });
  }
  function envoie(fichier) {
    var endpoint = window.__persoUpload;
    if (!endpoint) return Promise.resolve(null);
    return fetch(endpoint, { method: "POST", headers: { "Content-Type": fichier.type }, body: fichier })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.error || r.status); });
      })
      .then(function (j) { if (!j || !j.url) throw new Error("no_url"); return j; });
  }
  function textesRemplis() {
    var sortie = {};
    champsGabarit().forEach(function (champ) {
      var v = valeurTexte(champ.cle);
      if (v) sortie[champ.cle] = v;
    });
    return sortie;
  }
  function proprietes(j) {
    var props = {
      _perso: "1",
      _perso_url: j.url,
      _perso_preview: j.preview || j.url,
      _perso_crop: "50,50,1.00",
      _perso_crop_ok: "1",
      _perso_orient: "portrait",
      _pelemele: "1",
      _pelemele_gabarit: etat.gabarit
    };
    if (etat.gabarit === "nombre") props._pelemele_nombre = nombreActuel();
    if (COMPTES_LIM[cleCompte()]) props._pelemele_cases = String(compte(cleCompte()));
    if (etat.gabarit === "grille") props._pelemele_texte_style = etat.texteStyle;
    if (etat.gabarit === "coeur") props._pelemele_coeur_style = coeurStyle();
    if (etat.gabarit === "decalee") props._pelemele_decalee_style = decaleeStyle();
    props._pelemele_fond = estPleinBord() ? "blanc" : etat.fond;
    /* ⛔ LES PHOTOS SOURCES SUIVENT LA COMMANDE (Adrien, 11/08/2026 : la 1114 n'en avait
       aucune). Chaque photo est deja sur le serveur (envoiFond) ; on ecrit ici l'URL de
       chacune, dans l'ordre des cases du gabarit, pour que le collage se recompose au SAV.
       Une photo encore en cours d'envoi laisse une chaine vide : mieux vaut un trou visible
       qu'une liste qui pretend etre complete. */
    var srcs = [];
    affectations().forEach(function (ix) {
      if (ix < 0 || !photos[ix]) return;
      srcs.push(String(photos[ix].distantSource || photos[ix].distant || ""));
    });
    if (srcs.length) props._pelemele_sources = JSON.stringify(srcs);
    if (etat.police) {
      /* « modern (2) » : le nom pour le code, le rang pour l'oeil. */
      var rg = rangPolice(etat.police);
      props._pelemele_police = rg ? etat.police + " (" + rg + ")" : etat.police;
    }
    var encresGab = etat.encres[etat.gabarit];
    if (encresGab && Object.keys(encresGab).length) props._pelemele_encres = JSON.stringify(encresGab);
    var t = textesRemplis();
    if (Object.keys(t).length) props._pelemele_textes = JSON.stringify(t);
    return props;
  }
  function majOccupe(actif) {
    [$("#pdp-add"), $("#pdp-sticky-add")].forEach(function (el) {
      if (!el) return;
      el.disabled = actif;
      el.style.opacity = actif ? ".6" : "";
      el.style.cursor = actif ? "progress" : "";
    });
  }
  function demandeFormat() {
    var pont = window.__pdpPontPerso || {};
    var gi = pont.groupeFormat && pont.groupeFormat();
    if (gi && gi.grp) {
      if (window.__persoDefilerVers) window.__persoDefilerVers(gi.grp);
      else gi.grp.scrollIntoView({ behavior: "smooth", block: "center" });
      gi.grp.classList.add("pdp-option--ask");
      setTimeout(function () { gi.grp.classList.remove("pdp-option--ask"); }, 1400);
    }
  }
  /* ⛔ LE CLIGNOTEMENT CERNE CHAQUE CASE, PAS L'AFFICHE ENTIERE (Adrien, 23/08/2026 : « ca met un
     highlight autour de chaque case de photo, comme pour les formats sur les pages produit
     collection »). Les cases du collage sont PEINTES DANS UN CANVAS : aucune n'est un element,
     donc aucune ne peut porter une bordure CSS. On pose donc une couche de rectangles vides
     par-dessus la scene, AUX MEMES COORDONNEES QUE CELLES QUE `caseAuPoint` LIT POUR ROUTER UN
     CLIC. Une seule geometrie sert au clic et au designe : si l'un vise juste, l'autre aussi, et
     un gabarit ajoute demain n'a pas deux endroits a mettre d'accord.

     ⛔ ET LA CLASSE SE POSE TOUT DE SUITE, JAMAIS DANS UN `requestAnimationFrame`. Mesure du
     23/08/2026 dans son Chrome, sur la fiche pele-mele en vue large : la classe n'apparaissait
     JAMAIS. `ajoute()` ouvrait le selecteur de fichiers dans la foulee ; la fenetre native prend
     le focus, Chrome suspend les rAF d'un onglet occulte, et l'image demandee n'arrivait qu'apres
     la fermeture du dialogue, donc APRES le retrait programme a 1600 ms. Le compteur de rAF est
     reste a zero pendant que la temporisation, elle, tirait : un clignotement qui ne clignote
     jamais, et rien dans la console. Une animation qui doit se voir ne se met pas en file.

     ⛔ ET LE SELECTEUR DE FICHIERS NE S'OUVRE PLUS ICI. Le CTA dit maintenant « Cliquez sur une
     case pour importer » : ouvrir le dialogue a sa place designerait la case avec une fenetre
     par-dessus, et le mot serait faux. Les cases restent cliquables, c'est tout le propos. */
  var minuterieDesigne = null;
  function designeCasesVides() {
    var hote = scene.parentNode;
    if (!hote) return 0;
    var r = scene.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var vieille = hote.querySelector(".pelemele-ask");
    if (vieille && vieille.parentNode) vieille.parentNode.removeChild(vieille);
    if (minuterieDesigne) { clearTimeout(minuterieDesigne); minuterieDesigne = null; }
    var gb = gabarit();
    var boites = [];
    if (gb.id === "nombre" || gb.id === "coeur" || gb.id === "lettres") {
      (tuilesEcran(r.width, r.height) || []).forEach(function (q) {
        if (q.diamant) boites.push([q.cx - q.rr, q.cy - q.rr, q.rr * 2, q.rr * 2]);
        else boites.push([q.x, q.y, q.w, q.h]);
      });
    } else {
      var cs = gb.id === "damier-love" ? geometrieDamier(lettresDamier()).photos : casesCourantes();
      cs.forEach(function (c) {
        boites.push([c[0] * r.width, c[1] * r.height, c[2] * r.width, c[3] * r.height]);
      });
    }
    var aff = affectations(boites.length);
    var couche = document.createElement("div");
    couche.className = "pelemele-ask";
    var poses = 0;
    boites.forEach(function (b, i) {
      if (aff[i] >= 0) return;
      if (!(b[2] > 2 && b[3] > 2)) return;
      var d = document.createElement("div");
      d.className = "pelemele-ask__case";
      d.style.left = b[0] + "px"; d.style.top = b[1] + "px";
      d.style.width = b[2] + "px"; d.style.height = b[3] + "px";
      couche.appendChild(d); poses += 1;
    });
    if (!poses) return 0;
    hote.appendChild(couche);
    minuterieDesigne = setTimeout(function () {
      if (couche.parentNode) couche.parentNode.removeChild(couche);
      minuterieDesigne = null;
    }, 1700);
    return poses;
  }
  window.__pelemeleDesigneCases = designeCasesVides;

  function ajoute() {
    if (occupe) return;
    var pont = window.__pdpPontPerso || {};
    if (!photos.length) {
      designeCasesVides();
      if (window.murToast) window.murToast(T.need_photo || "Importez au moins une photo");
      return;
    }
    if (pont.formatChoisi && !pont.formatChoisi()) { demandeFormat(); return; }
    var v = pont.varianteCourante && pont.varianteCourante();
    if (!v) v = (window.__pdpVariants || [])[0];
    if (!v) return;
    if (window.__persoFunnel) window.__persoFunnel("panier");
    occupe = true; majOccupe(true);
    composeImpression()
      .then(envoie)
      .then(function (j) {
        var qte = 1, qi = $("#pdp-qty");
        if (qi && Number(qi.value) > 0) qte = Math.floor(Number(qi.value));
        var items = { items: [{ id: v.id, quantity: qte, properties: proprietes(j) }] };
        if (window.murAddToCart) return window.murAddToCart(items);
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(items)
        }).then(function () { if (window.murRefreshCart) return window.murRefreshCart(); });
      })
      .catch(function () {
        if (window.murToast) window.murToast(TI.perso_upload_failed || "Envoi impossible, réessayez");
      })
      .then(function () { occupe = false; majOccupe(false); });
  }
  /* ============================================================================================
   * VOIR LE RENDU AVANT D'ACHETER (Adrien, 20/08/2026).
   *
   * « Quand la personne a importé ses photos, le CTA devient "voir le rendu", ça ouvre une
   * modale fermable en grand avec le rendu et un bouton "ajout au panier" en bas. Le rendu est
   * simplement l'équivalent de ce qu'on a au bouton download et ce qui part à l'impression. »
   *
   * ⛔ LE RENDU VIENT DE `composeImpression()`, LA MEME FONCTION QUE LE TELECHARGEMENT ET QUE LA
   * PRESSE. C'est la regle du produit depuis le premier jour : une seule fonction de dessin pour
   * l'apercu et pour l'impression. En fabriquer une seconde pour la modale, c'est promettre au
   * client une image qui pourrait differer de celle qu'on tire, et cette divergence-la ne se
   * voit qu'a la reception du colis.
   * ========================================================================================== */

  /* ⛔ LE LIBELLE SE REPREND A CHAQUE PASSAGE, IL NE SE CAPTURE PAS UNE FOIS. `product.js`
     reecrit ce bouton a chaque changement de variante, prix compris : un libelle memorise au
     chargement serait ecrase au premier clic sur une taille, et le bouton redirait « Ajouter au
     panier » alors qu'il ouvre une modale. On retient donc le texte du PANIER chaque fois qu'on
     le voit passer, et on ne touche qu'a la tete, avant le point median : le prix reste celui
     que product.js vient d'ecrire. */
  /* ⛔ QUAND CE CHEMIN EST LE CHEMIN D'ACHAT, LA PAGE NE GARDE PAS SON BLOC EN DOUBLE (Adrien,
     20/08/2026). Le drapeau se pose AVANT les retours anticipes du libelle : un bouton dont la
     tete porte un etat sort de la fonction plus bas, et la page serait restee avec ses deux jeux
     de formats. Il se pose aussi a chaque changement de photos, puisque c'est leur presence qui
     ouvre ou ferme ce chemin. */
  function achatParModale() {
    /* ⛔ SUR TELEPHONE, C'EST LE CHEMIN, AVEC OU SANS PHOTO (Adrien, 20/08/2026 : « a l'etat
       "importer ma photo" il faut virer ca aussi »). Je l'avais d'abord conditionne aux photos :
       un client qui n'avait encore rien depose gardait sous les yeux les formats, la quantite et
       « Choisissez une taille », c'est-a-dire exactement le bloc d'achat en double qu'il fallait
       retirer. Et le pele-mele a TOUJOURS quelque chose a montrer : le gabarit se dessine avec
       ses cases vides, comme sur sa capture. */
    return !!(window.murEstMobile && window.murEstMobile());
  }
  function majCtaRendu() {
    if (window.murAchatParModale) window.murAchatParModale(achatParModale);
    /* Le meme endroit dit les deux choses : ce rappel a lieu a chaque changement de photos. */
    if (window.murPhotoPosee) window.murPhotoPosee(function () { return photos.length > 0; });
    var viaModale = achatParModale();
    var b = $("#pdp-add");
    var st = $("#pdp-sticky-add");
    if (!b || !st) return;
    /* ⛔ LE LIBELLE DU PANIER VIENT DU THEME, PAS DU BOUTON. Ma premiere version le devinait en
       relisant le texte affiche : elle a fini par memoriser « Choisissez une taille », que
       `product.js` ecrit quand aucune taille n'est choisie, et le bouton l'a garde apres la
       fermeture de la fenetre (Adrien, 20/08/2026). `data-label-add` porte la vraie phrase,
       traduite, et il ne bouge jamais. */
    var ajouter = st.getAttribute("data-label-add");
    if (!ajouter) return;
    var voir = T.voir_rendu || "Voir le rendu";
    var t = b.textContent || "";
    var i = t.indexOf(" · ");
    var tete = i >= 0 ? t.slice(0, i) : t;
    var queue = i >= 0 ? t.slice(i) : "";
    /* ⛔⛔ ET ON NE RECOUVRE JAMAIS UN ETAT. « Choisissez une taille » n'est pas un libelle, c'est
       ce qui MANQUE au client : le remplacer par « Voir le rendu » lui cache la raison pour
       laquelle son clic ne fera rien, et c'est ce qu'il a vu. On ne touche donc qu'a un bouton
       qui propose vraiment d'ajouter, ou qui porte deja notre libelle. */
    /* ⛔ ... SAUF QUAND LA FENETRE EST LE CHEMIN D'ACHAT, et c'est la meme raison retournee. La
       regle protegeait un client qui pouvait lire « Choisissez une taille » sans voir de quoi en
       choisir une, les formats etant restes loin au-dessus. Depuis que ce chemin RETIRE les
       formats de la page pour les mettre dans la fenetre, garder cet etat sur le bouton est le
       pire des deux : plus aucune taille nulle part, et un mot qui ne dit pas que le clic ouvre
       justement de quoi la choisir. Le clic, lui, a toujours fait quelque chose. */
    /* ⛔ ON MET L'ETAT DE COTE AVANT DE LE COUVRIR. « Choisissez une taille » appartient a
       `product.js` ; en le remplacant par « Voir le rendu » sur la page, on efface le seul
       endroit ou la fenetre pouvait le lire. Elle le reprend ici, mot pour mot et traduit, plutot
       que d'en ecrire une seconde version qui vieillirait de son cote (Adrien, 20/08/2026 : « ce
       n'est pas "ajouter au panier" mais "choisissez une taille" si aucune taille n'a ete
       choisie »). */
    if (tete !== ajouter && tete !== voir) window.murEtatAchat = tete;
    if (tete !== ajouter && tete !== voir && !viaModale) return;
    /* ⚠️ ET LE LIBELLE SUIT LE MEME SEUIL : sur grand ecran le bouton dit « Ajouter au panier »,
       parce que c'est ce qu'il fait. Un « Voir le rendu » qui ajouterait au panier serait un
       mensonge de plus. */
    var veut = viaModale ? voir : ajouter;
    if (tete !== veut) b.textContent = veut + queue;
  }

  /* ⛔ LA FENETRE VIT DANS `global.js`, PARTAGEE PAR LES TROIS PRODUITS PERSONNALISES (Adrien,
     20/08/2026 : « pour TOUS LES PRODUITS PERSONNALISES [...] EXACTEMENT ce qui est envoye pour
     impression, pas de concession possible »). Elle ne dessine rien : on lui donne
     `composeImpression`, c'est-a-dire la fonction qui fabrique le fichier envoye a l'impression,
     et elle montre son resultat. Ecrite ici, elle aurait ete ecrite deux fois de plus. */
  function ouvreRendu() {
    if (occupe) return;
    occupe = true; majOccupe(true);
    var st = $("#pdp-sticky-add");
    window.murRenduModale({
      compose: composeImpression,
      fermer: T.fermer,
      libelleAjout: (st && st.getAttribute("data-label-add")) || "Ajouter au panier",
      /* Le seul mot que la fenetre a le droit de remplacer sur le bouton : il appartient au
         bouton de la fiche, et dans la fenetre le rendu est deja sous les yeux. */
      libelleVoir: T.voir_rendu || "Voir le rendu",
      /* ⛔ LA LISTE VIT DANS `global.js`, une seule fois : trois copies finiraient par ne plus
         designer les memes blocs, et c'est celle qu'on ne regarde pas qui oublierait la
         bordure blanche. */
      commandes: window.murCommandesAchat,
      quantite: ".pdp-buy-actions > .pdp-qty-sel",
      reassurance: ".pdp-avis__note",
      onAjouter: ajoute,
      /* ⛔ LE LIBELLE SE REMET A LA FERMETURE. Sans ce rappel, le bouton gardait celui que
         `product.js` avait ecrit pendant que la fenetre etait ouverte. */
      onFermer: majCtaRendu,
    }).catch(function () {
      if (window.murToast) window.murToast(TI.perso_upload_failed || "Rendu impossible, réessayez");
    }).then(function () { occupe = false; majOccupe(false); majCtaRendu(); });
  }

  /* Interception en amont de product.js : en capture sur le document, AVANT la phase
     cible. Un écouteur capture posé sur le bouton lui-même passerait APRÈS celui de
     product.js (ordre d'enregistrement à la cible), et la ligne perso partirait vide. */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest("#pdp-add")) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      /* ⛔ SUR TELEPHONE ET AVEC DES PHOTOS, ON MONTRE AVANT DE VENDRE. Sur grand ecran
         l'apercu occupe deja la moitie de la page : une fenetre qui le remontre ajoute un clic
         et n'apprend rien (Adrien, 20/08/2026). Sans photo il n'y a rien a montrer non plus :
         le bouton garde alors son geste d'origine, et le configurateur reclame une photo. */
      if (achatParModale()) ouvreRendu();
      else ajoute();
    }
  }, true);

  /* ⛔ LE PELE-MELE EXPOSE SON PROPRE AJOUT AU PANIER, ET C'EST LE SIEN QUI DOIT SERVIR.
     L'atelier plein ecran (`perso-atelier.js`) appelle `window.__persoAjouter` depuis son second
     ecran. `product.js` y met SA fonction, qui ne sait rien du collage : sur le pele-mele, le
     panier restait a zero, sans erreur et sans message (mesure du 23/08/2026 sur WebKit en profil
     iPhone : panier 0 avant, 0 apres, aucune ligne creee).
     ⚠️ ET ON N'APPELLE PAS `#pdp-add` A LA PLACE : l'interception ci-dessous ouvrirait la
     fenetre de rendu PAR-DESSUS l'atelier sur telephone. Chaque configurateur expose sa
     fonction, l'atelier appelle celle de la page ou il se trouve.
     ⚠️ CE FICHIER NE SE CHARGE QUE SUR LE PELE-MELE : l'affectation ne peut donc pas ecraser
     celle d'une autre fiche. `product.js`, lui, se charge partout et pose la garde inverse. */
  window.__persoAjouter = ajoute;

  majBarre(); majZone(); majPile(); majStyleAffiche(); chargePolices(); planifie(); majCtaRendu();
  /* ⛔ ET LE LIBELLE SE REDIT QUAND `product.js` REECRIT LE BOUTON. Mesure du 20/08/2026 en
     production : la page s'ouvrait sur « Choisissez une taille » alors que la fenetre est le
     chemin d'achat et que la page n'a plus un seul format. Mon appel avait bien eu lieu, mais
     `product.js` repasse APRES (il rejoue sa rangee d'achat dans une macrotache, precisement
     pour passer apres tous les scripts) et recouvre le libelle. Un appel de plus au chargement
     ne suffirait pas : le meme recouvrement a lieu a chaque changement de variante.
     ⚠️ PAS DE BOUCLE : `majCtaRendu` n'ecrit que si la tete differe de ce qu'elle veut, donc le
     second passage ne touche a rien et l'observateur se tait. */
  if (window.MutationObserver) {
    var boutonAchat = $("#pdp-add");
    if (boutonAchat) {
      new MutationObserver(function () { majCtaRendu(); })
        .observe(boutonAchat, { childList: true, characterData: true, subtree: true });
    }
  }
  /* ⛔ ET LE LIBELLE SE RELIT QUAND LA LARGEUR CHANGE. Sans ca, une rotation de telephone ou une
     fenetre redimensionnee laisse « Voir le rendu » sur un bouton qui ajoute au panier, et
     inversement. Le seuil est une mesure, pas un etat fige au chargement. */
  if (window.matchMedia) {
    var mq = window.matchMedia("(max-width:900px)");
    var suivre = function () { majCtaRendu(); };
    if (mq.addEventListener) mq.addEventListener("change", suivre);
    else if (mq.addListener) mq.addListener(suivre);
  }

  /* Sonde de vérification (aucun usage client) : rendre un état arbitraire hors
     écran sans dépendre du rAF de l'aperçu. Sert aux contrôles des gabarits. */
  window.__pdpPeleMeleSonde = function (surcharge, largeur) {
    var sauve = JSON.parse(JSON.stringify(etat));
    Object.keys(surcharge || {}).forEach(function (k) { etat[k] = surcharge[k]; });
    cacheRef = null;
    var c = document.createElement("canvas");
    c.width = largeur || 400; c.height = Math.round(c.width / RATIO);
    dessine(c.getContext("2d"), c.width, c.height, true);
    var d = c.toDataURL("image/jpeg", 0.72);
    Object.keys(etat).forEach(function (k) { etat[k] = sauve[k]; });
    cacheRef = null;
    return d;
  };
})();
